<?xml version="1.0" ?>
<HED xmlns:xsi="http://www.w3.org/2001/XMLSchema-instance" version="8.3.0" xsi:noNamespaceSchemaLocation="https://github.com/hed-standard/hed-specification/raw/master/hedxml/HED8.0.0.xsd">
   <prologue>The HED standard schema is a hierarchically-organized vocabulary for annotating events and experimental structure. HED annotations consist of comma-separated tags drawn from this vocabulary. This vocabulary can be augmented by terms drawn from specialized library schema. 

Each term in this vocabulary has a human-readable description and may include additional attributes that give additional properties or that specify how tools should treat the tag during analysis. The meaning of these attributes is described in the Additional schema properties section.</prologue>
   <schema>
      <node>
         <name>Event</name>
         <description>Something that happens at a given time and (typically) place. Elements of this tag subtree designate the general category in which an event falls.</description>
         <attribute>
            <name>suggestedTag</name>
            <value>Task-property</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0012001</value>
         </attribute>
         <node>
            <name>Sensory-event</name>
            <description>Something perceivable by the participant. An event meant to be an experimental stimulus should include the tag Task-property/Task-event-role/Experimental-stimulus.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Task-event-role</value>
               <value>Sensory-presentation</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012002</value>
            </attribute>
         </node>
         <node>
            <name>Agent-action</name>
            <description>Any action engaged in by an agent (see the Agent subtree for agent categories). A participant response to an experiment stimulus should include the tag Agent-property/Agent-task-role/Experiment-participant.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Task-event-role</value>
               <value>Agent</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012003</value>
            </attribute>
         </node>
         <node>
            <name>Data-feature</name>
            <description>An event marking the occurrence of a data feature such as an interictal spike or alpha burst that is often added post hoc to the data record.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Data-property</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012004</value>
            </attribute>
         </node>
         <node>
            <name>Experiment-control</name>
            <description>An event pertaining to the physical control of the experiment during its operation.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012005</value>
            </attribute>
         </node>
         <node>
            <name>Experiment-procedure</name>
            <description>An event indicating an experimental procedure, as in performing a saliva swab during the experiment or administering a survey.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012006</value>
            </attribute>
         </node>
         <node>
            <name>Experiment-structure</name>
            <description>An event specifying a change-point of the structure of experiment. This event is typically used to indicate a change in experimental conditions or tasks.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012007</value>
            </attribute>
         </node>
         <node>
            <name>Measurement-event</name>
            <description>A discrete measure returned by an instrument.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Data-property</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012008</value>
            </attribute>
         </node>
      </node>
      <node>
         <name>Agent</name>
         <description>Someone or something that takes an active role or produces a specified effect.The role or effect may be implicit. Being alive or performing an activity such as a computation may qualify something to be an agent. An agent may also be something that simulates something else.</description>
         <attribute>
            <name>suggestedTag</name>
            <value>Agent-property</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0012009</value>
         </attribute>
         <node>
            <name>Animal-agent</name>
            <description>An agent that is an animal.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012010</value>
            </attribute>
         </node>
         <node>
            <name>Avatar-agent</name>
            <description>An agent associated with an icon or avatar representing another agent.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012011</value>
            </attribute>
         </node>
         <node>
            <name>Controller-agent</name>
            <description>Experiment control software or hardware.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012012</value>
            </attribute>
         </node>
         <node>
            <name>Human-agent</name>
            <description>A person who takes an active role or produces a specified effect.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012013</value>
            </attribute>
         </node>
         <node>
            <name>Robotic-agent</name>
            <description>An agent mechanical device capable of performing a variety of often complex tasks on command or by being programmed in advance.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012014</value>
            </attribute>
         </node>
         <node>
            <name>Software-agent</name>
            <description>An agent computer program that interacts with the participant in an active role such as an AI advisor.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012015</value>
            </attribute>
         </node>
      </node>
      <node>
         <name>Action</name>
         <description>Do something.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0012016</value>
         </attribute>
         <node>
            <name>Communicate</name>
            <description>Action conveying knowledge of or about something.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012017</value>
            </attribute>
            <node>
               <name>Communicate-gesturally</name>
               <description>Communicate non-verbally using visible bodily actions, either in place of speech or together and in parallel with spoken words. Gestures include movement of the hands, face, or other parts of the body.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Move-face</value>
                  <value>Move-upper-extremity</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012018</value>
               </attribute>
               <node>
                  <name>Clap-hands</name>
                  <description>Strike the palms of against one another resoundingly, and usually repeatedly, especially to express approval.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012019</value>
                  </attribute>
               </node>
               <node>
                  <name>Clear-throat</name>
                  <description>Cough slightly so as to speak more clearly, attract attention, or to express hesitancy before saying something awkward.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-head</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012020</value>
                  </attribute>
               </node>
               <node>
                  <name>Frown</name>
                  <description>Express disapproval, displeasure, or concentration, typically by turning down the corners of the mouth.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012021</value>
                  </attribute>
               </node>
               <node>
                  <name>Grimace</name>
                  <description>Make a twisted expression, typically expressing disgust, pain, or wry amusement.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012022</value>
                  </attribute>
               </node>
               <node>
                  <name>Nod-head</name>
                  <description>Tilt head in alternating up and down arcs along the sagittal plane. It is most commonly, but not universally, used to indicate agreement, acceptance, or acknowledgement.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-head</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012023</value>
                  </attribute>
               </node>
               <node>
                  <name>Pump-fist</name>
                  <description>Raise with fist clenched in triumph or affirmation.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012024</value>
                  </attribute>
               </node>
               <node>
                  <name>Raise-eyebrows</name>
                  <description>Move eyebrows upward.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012025</value>
                  </attribute>
               </node>
               <node>
                  <name>Shake-fist</name>
                  <description>Clench hand into a fist and shake to demonstrate anger.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012026</value>
                  </attribute>
               </node>
               <node>
                  <name>Shake-head</name>
                  <description>Turn head from side to side as a way of showing disagreement or refusal.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-head</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012027</value>
                  </attribute>
               </node>
               <node>
                  <name>Shhh</name>
                  <description>Place finger over lips and possibly uttering the syllable shhh to indicate the need to be quiet.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012028</value>
                  </attribute>
               </node>
               <node>
                  <name>Shrug</name>
                  <description>Lift shoulders up towards head to indicate a lack of knowledge about a particular topic.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                     <value>Move-torso</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012029</value>
                  </attribute>
               </node>
               <node>
                  <name>Smile</name>
                  <description>Form facial features into a pleased, kind, or amused expression, typically with the corners of the mouth turned up and the front teeth exposed.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012030</value>
                  </attribute>
               </node>
               <node>
                  <name>Spread-hands</name>
                  <description>Spread hands apart to indicate ignorance.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012031</value>
                  </attribute>
               </node>
               <node>
                  <name>Thumb-up</name>
                  <description>Extend the thumb upward to indicate approval.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012032</value>
                  </attribute>
               </node>
               <node>
                  <name>Thumbs-down</name>
                  <description>Extend the thumb downward to indicate disapproval.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012033</value>
                  </attribute>
               </node>
               <node>
                  <name>Wave</name>
                  <description>Raise hand and move left and right, as a greeting or sign of departure.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-upper-extremity</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012034</value>
                  </attribute>
               </node>
               <node>
                  <name>Widen-eyes</name>
                  <description>Open eyes and possibly with eyebrows lifted especially to express surprise or fear.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012035</value>
                  </attribute>
               </node>
               <node>
                  <name>Wink</name>
                  <description>Close and open one eye quickly, typically to indicate that something is a joke or a secret or as a signal of affection or greeting.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Move-face</value>
                     <value>Move-eyes</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012036</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Communicate-musically</name>
               <description>Communicate using music.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012037</value>
               </attribute>
               <node>
                  <name>Hum</name>
                  <description>Make a low, steady continuous sound like that of a bee. Sing with the lips closed and without uttering speech.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012038</value>
                  </attribute>
               </node>
               <node>
                  <name>Play-instrument</name>
                  <description>Make musical sounds using an instrument.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012039</value>
                  </attribute>
               </node>
               <node>
                  <name>Sing</name>
                  <description>Produce musical tones by means of the voice.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012040</value>
                  </attribute>
               </node>
               <node>
                  <name>Vocalize</name>
                  <description>Utter vocal sounds.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012041</value>
                  </attribute>
               </node>
               <node>
                  <name>Whistle</name>
                  <description>Produce a shrill clear sound by forcing breath out or air in through the puckered lips.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012042</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Communicate-vocally</name>
               <description>Communicate using mouth or vocal cords.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012043</value>
               </attribute>
               <node>
                  <name>Cry</name>
                  <description>Shed tears associated with emotions, usually sadness but also joy or frustration.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012044</value>
                  </attribute>
               </node>
               <node>
                  <name>Groan</name>
                  <description>Make a deep inarticulate sound in response to pain or despair.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012045</value>
                  </attribute>
               </node>
               <node>
                  <name>Laugh</name>
                  <description>Make the spontaneous sounds and movements of the face and body that are the instinctive expressions of lively amusement and sometimes also of contempt or derision.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012046</value>
                  </attribute>
               </node>
               <node>
                  <name>Scream</name>
                  <description>Make loud, vociferous cries or yells to express pain, excitement, or fear.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012047</value>
                  </attribute>
               </node>
               <node>
                  <name>Shout</name>
                  <description>Say something very loudly.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012048</value>
                  </attribute>
               </node>
               <node>
                  <name>Sigh</name>
                  <description>Emit a long, deep, audible breath expressing sadness, relief, tiredness, or a similar feeling.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012049</value>
                  </attribute>
               </node>
               <node>
                  <name>Speak</name>
                  <description>Communicate using spoken language.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012050</value>
                  </attribute>
               </node>
               <node>
                  <name>Whisper</name>
                  <description>Speak very softly using breath without vocal cords.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012051</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Move</name>
            <description>Move in a specified direction or manner. Change position or posture.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012052</value>
            </attribute>
            <node>
               <name>Breathe</name>
               <description>Inhale or exhale during respiration.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012053</value>
               </attribute>
               <node>
                  <name>Blow</name>
                  <description>Expel air through pursed lips.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012054</value>
                  </attribute>
               </node>
               <node>
                  <name>Cough</name>
                  <description>Suddenly and audibly expel air from the lungs through a partially closed glottis, preceded by inhalation.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012055</value>
                  </attribute>
               </node>
               <node>
                  <name>Exhale</name>
                  <description>Blow out or expel breath.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012056</value>
                  </attribute>
               </node>
               <node>
                  <name>Hiccup</name>
                  <description>Involuntarily spasm the diaphragm and respiratory organs, with a sudden closure of the glottis and a characteristic sound like that of a cough.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012057</value>
                  </attribute>
               </node>
               <node>
                  <name>Hold-breath</name>
                  <description>Interrupt normal breathing by ceasing to inhale or exhale.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012058</value>
                  </attribute>
               </node>
               <node>
                  <name>Inhale</name>
                  <description>Draw in with the breath through the nose or mouth.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012059</value>
                  </attribute>
               </node>
               <node>
                  <name>Sneeze</name>
                  <description>Suddenly and violently expel breath through the nose and mouth.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012060</value>
                  </attribute>
               </node>
               <node>
                  <name>Sniff</name>
                  <description>Draw in air audibly through the nose to detect a smell, to stop it from running, or to express contempt.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012061</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Move-body</name>
               <description>Move entire body.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012062</value>
               </attribute>
               <node>
                  <name>Bend</name>
                  <description>Move body in a bowed or curved manner.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012063</value>
                  </attribute>
               </node>
               <node>
                  <name>Dance</name>
                  <description>Perform a purposefully selected sequences of human movement often with aesthetic or symbolic value. Move rhythmically to music, typically following a set sequence of steps.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012064</value>
                  </attribute>
               </node>
               <node>
                  <name>Fall-down</name>
                  <description>Lose balance and collapse.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012065</value>
                  </attribute>
               </node>
               <node>
                  <name>Flex</name>
                  <description>Cause a muscle to stand out by contracting or tensing it. Bend a limb or joint.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012066</value>
                  </attribute>
               </node>
               <node>
                  <name>Jerk</name>
                  <description>Make a quick, sharp, sudden movement.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012067</value>
                  </attribute>
               </node>
               <node>
                  <name>Lie-down</name>
                  <description>Move to a horizontal or resting position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012068</value>
                  </attribute>
               </node>
               <node>
                  <name>Recover-balance</name>
                  <description>Return to a stable, upright body position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012069</value>
                  </attribute>
               </node>
               <node>
                  <name>Shudder</name>
                  <description>Tremble convulsively, sometimes as a result of fear or revulsion.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012070</value>
                  </attribute>
               </node>
               <node>
                  <name>Sit-down</name>
                  <description>Move from a standing to a sitting position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012071</value>
                  </attribute>
               </node>
               <node>
                  <name>Sit-up</name>
                  <description>Move from lying down to a sitting position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012072</value>
                  </attribute>
               </node>
               <node>
                  <name>Stand-up</name>
                  <description>Move from a sitting to a standing position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012073</value>
                  </attribute>
               </node>
               <node>
                  <name>Stretch</name>
                  <description>Straighten or extend body or a part of body to its full length, typically so as to tighten muscles or in order to reach something.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012074</value>
                  </attribute>
               </node>
               <node>
                  <name>Stumble</name>
                  <description>Trip or momentarily lose balance and almost fall.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012075</value>
                  </attribute>
               </node>
               <node>
                  <name>Turn</name>
                  <description>Change or cause to change direction.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012076</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Move-body-part</name>
               <description>Move one part of a body.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012077</value>
               </attribute>
               <node>
                  <name>Move-eyes</name>
                  <description>Move eyes.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012078</value>
                  </attribute>
                  <node>
                     <name>Blink</name>
                     <description>Shut and open the eyes quickly.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012079</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Close-eyes</name>
                     <description>Lower and keep eyelids in a closed position.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012080</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Fixate</name>
                     <description>Direct eyes to a specific point or target.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012081</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Inhibit-blinks</name>
                     <description>Purposely prevent blinking.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012082</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Open-eyes</name>
                     <description>Raise eyelids to expose pupil.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012083</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Saccade</name>
                     <description>Move eyes rapidly between fixation points.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012084</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Squint</name>
                     <description>Squeeze one or both eyes partly closed in an attempt to see more clearly or as a reaction to strong light.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012085</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Stare</name>
                     <description>Look fixedly or vacantly at someone or something with eyes wide open.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012086</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Move-face</name>
                  <description>Move the face or jaw.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012087</value>
                  </attribute>
                  <node>
                     <name>Bite</name>
                     <description>Seize with teeth or jaws an object or organism so as to grip or break the surface covering.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012088</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Burp</name>
                     <description>Noisily release air from the stomach through the mouth. Belch.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012089</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Chew</name>
                     <description>Repeatedly grinding, tearing, and or crushing with teeth or jaws.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012090</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Gurgle</name>
                     <description>Make a hollow bubbling sound like that made by water running out of a bottle.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012091</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Swallow</name>
                     <description>Cause or allow something, especially food or drink to pass down the throat.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012092</value>
                     </attribute>
                     <node>
                        <name>Gulp</name>
                        <description>Swallow quickly or in large mouthfuls, often audibly, sometimes to indicate apprehension.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012093</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Yawn</name>
                     <description>Take a deep involuntary inhalation with the mouth open often as a sign of drowsiness or boredom.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012094</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Move-head</name>
                  <description>Move head.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012095</value>
                  </attribute>
                  <node>
                     <name>Lift-head</name>
                     <description>Tilt head back lifting chin.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012096</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Lower-head</name>
                     <description>Move head downward so that eyes are in a lower position.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012097</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Turn-head</name>
                     <description>Rotate head horizontally to look in a different direction.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012098</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Move-lower-extremity</name>
                  <description>Move leg and/or foot.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012099</value>
                  </attribute>
                  <node>
                     <name>Curl-toes</name>
                     <description>Bend toes sometimes to grip.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012100</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Hop</name>
                     <description>Jump on one foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012101</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Jog</name>
                     <description>Run at a trot to exercise.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012102</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Jump</name>
                     <description>Move off the ground or other surface through sudden muscular effort in the legs.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012103</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Kick</name>
                     <description>Strike out or flail with the foot or feet.Strike using the leg, in unison usually with an area of the knee or lower using the foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012104</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Pedal</name>
                     <description>Move by working the pedals of a bicycle or other machine.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012105</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Press-foot</name>
                     <description>Move by pressing foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012106</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Run</name>
                     <description>Travel on foot at a fast pace.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012107</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Step</name>
                     <description>Put one leg in front of the other and shift weight onto it.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012108</value>
                     </attribute>
                     <node>
                        <name>Heel-strike</name>
                        <description>Strike the ground with the heel during a step.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012109</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Toe-off</name>
                        <description>Push with toe as part of a stride.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012110</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Trot</name>
                     <description>Run at a moderate pace, typically with short steps.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012111</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Walk</name>
                     <description>Move at a regular pace by lifting and setting down each foot in turn never having both feet off the ground at once.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012112</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Move-torso</name>
                  <description>Move body trunk.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012113</value>
                  </attribute>
               </node>
               <node>
                  <name>Move-upper-extremity</name>
                  <description>Move arm, shoulder, and/or hand.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012114</value>
                  </attribute>
                  <node>
                     <name>Drop</name>
                     <description>Let or cause to fall vertically.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012115</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Grab</name>
                     <description>Seize suddenly or quickly. Snatch or clutch.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012116</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Grasp</name>
                     <description>Seize and hold firmly.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012117</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Hold-down</name>
                     <description>Prevent someone or something from moving by holding them firmly.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012118</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Lift</name>
                     <description>Raising something to higher position.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012119</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Make-fist</name>
                     <description>Close hand tightly with the fingers bent against the palm.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012120</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Point</name>
                     <description>Draw attention to something by extending a finger or arm.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012121</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Press</name>
                     <description>Apply pressure to something to flatten, shape, smooth or depress it. This action tag should be used to indicate key presses and mouse clicks.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Push</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012122</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Push</name>
                     <description>Apply force in order to move something away. Use Press to indicate a key press or mouse click.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Press</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012123</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Reach</name>
                     <description>Stretch out your arm in order to get or touch something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012124</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Release</name>
                     <description>Make available or set free.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012125</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Retract</name>
                     <description>Draw or pull back.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012126</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Scratch</name>
                     <description>Drag claws or nails over a surface or on skin.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012127</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Snap-fingers</name>
                     <description>Make a noise by pushing second finger hard against thumb and then releasing it suddenly so that it hits the base of the thumb.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012128</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Touch</name>
                     <description>Come into or be in contact with.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012129</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Perceive</name>
            <description>Produce an internal, conscious image through stimulating a sensory system.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012130</value>
            </attribute>
            <node>
               <name>Hear</name>
               <description>Give attention to a sound.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012131</value>
               </attribute>
            </node>
            <node>
               <name>See</name>
               <description>Direct gaze toward someone or something or in a specified direction.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012132</value>
               </attribute>
            </node>
            <node>
               <name>Sense-by-touch</name>
               <description>Sense something through receptors in the skin.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012133</value>
               </attribute>
            </node>
            <node>
               <name>Smell</name>
               <description>Inhale in order to ascertain an odor or scent.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012134</value>
               </attribute>
            </node>
            <node>
               <name>Taste</name>
               <description>Sense a flavor in the mouth and throat on contact with a substance.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012135</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Perform</name>
            <description>Carry out or accomplish an action, task, or function.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012136</value>
            </attribute>
            <node>
               <name>Close</name>
               <description>Act as to blocked against entry or passage.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012137</value>
               </attribute>
            </node>
            <node>
               <name>Collide-with</name>
               <description>Hit with force when moving.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012138</value>
               </attribute>
            </node>
            <node>
               <name>Halt</name>
               <description>Bring or come to an abrupt stop.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012139</value>
               </attribute>
            </node>
            <node>
               <name>Modify</name>
               <description>Change something.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012140</value>
               </attribute>
            </node>
            <node>
               <name>Open</name>
               <description>Widen an aperture, door, or gap, especially one allowing access to something.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012141</value>
               </attribute>
            </node>
            <node>
               <name>Operate</name>
               <description>Control the functioning of a machine, process, or system.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012142</value>
               </attribute>
            </node>
            <node>
               <name>Play</name>
               <description>Engage in activity for enjoyment and recreation rather than a serious or practical purpose.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012143</value>
               </attribute>
            </node>
            <node>
               <name>Read</name>
               <description>Interpret something that is written or printed.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012144</value>
               </attribute>
            </node>
            <node>
               <name>Repeat</name>
               <description>Make do or perform again.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012145</value>
               </attribute>
            </node>
            <node>
               <name>Rest</name>
               <description>Be inactive in order to regain strength, health, or energy.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012146</value>
               </attribute>
            </node>
            <node>
               <name>Ride</name>
               <description>Ride on an animal or in a vehicle. Ride conveys some notion that another agent has partial or total control of the motion.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012147</value>
               </attribute>
            </node>
            <node>
               <name>Write</name>
               <description>Communicate or express by means of letters or symbols written or imprinted on a surface.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012148</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Think</name>
            <description>Direct the mind toward someone or something or use the mind actively to form connected ideas.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012149</value>
            </attribute>
            <node>
               <name>Allow</name>
               <description>Allow access to something such as allowing a car to pass.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012150</value>
               </attribute>
            </node>
            <node>
               <name>Attend-to</name>
               <description>Focus mental experience on specific targets.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012151</value>
               </attribute>
            </node>
            <node>
               <name>Count</name>
               <description>Tally items either silently or aloud.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012152</value>
               </attribute>
            </node>
            <node>
               <name>Deny</name>
               <description>Refuse to give or grant something requested or desired by someone.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012153</value>
               </attribute>
            </node>
            <node>
               <name>Detect</name>
               <description>Discover or identify the presence or existence of something.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012154</value>
               </attribute>
            </node>
            <node>
               <name>Discriminate</name>
               <description>Recognize a distinction.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012155</value>
               </attribute>
            </node>
            <node>
               <name>Encode</name>
               <description>Convert information or an instruction into a particular form.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012156</value>
               </attribute>
            </node>
            <node>
               <name>Evade</name>
               <description>Escape or avoid, especially by cleverness or trickery.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012157</value>
               </attribute>
            </node>
            <node>
               <name>Generate</name>
               <description>Cause something, especially an emotion or situation to arise or come about.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012158</value>
               </attribute>
            </node>
            <node>
               <name>Identify</name>
               <description>Establish or indicate who or what someone or something is.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012159</value>
               </attribute>
            </node>
            <node>
               <name>Imagine</name>
               <description>Form a mental image or concept of something.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012160</value>
               </attribute>
            </node>
            <node>
               <name>Judge</name>
               <description>Evaluate evidence to make a decision or form a belief.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012161</value>
               </attribute>
            </node>
            <node>
               <name>Learn</name>
               <description>Adaptively change behavior as the result of experience.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012162</value>
               </attribute>
            </node>
            <node>
               <name>Memorize</name>
               <description>Adaptively change behavior as the result of experience.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012163</value>
               </attribute>
            </node>
            <node>
               <name>Plan</name>
               <description>Think about the activities required to achieve a desired goal.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012164</value>
               </attribute>
            </node>
            <node>
               <name>Predict</name>
               <description>Say or estimate that something will happen or will be a consequence of something without having exact information.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012165</value>
               </attribute>
            </node>
            <node>
               <name>Recall</name>
               <description>Remember information by mental effort.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012166</value>
               </attribute>
            </node>
            <node>
               <name>Recognize</name>
               <description>Identify someone or something from having encountered them before.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012167</value>
               </attribute>
            </node>
            <node>
               <name>Respond</name>
               <description>React to something such as a treatment or a stimulus.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012168</value>
               </attribute>
            </node>
            <node>
               <name>Switch-attention</name>
               <description>Transfer attention from one focus to another.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012169</value>
               </attribute>
            </node>
            <node>
               <name>Track</name>
               <description>Follow a person, animal, or object through space or time.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012170</value>
               </attribute>
            </node>
         </node>
      </node>
      <node>
         <name>Item</name>
         <description>An independently existing thing (living or nonliving).</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0012171</value>
         </attribute>
         <node>
            <name>Biological-item</name>
            <description>An entity that is biological, that is related to living organisms.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012172</value>
            </attribute>
            <node>
               <name>Anatomical-item</name>
               <description>A biological structure, system, fluid or other substance excluding single molecular entities.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012173</value>
               </attribute>
               <node>
                  <name>Body</name>
                  <description>The biological structure representing an organism.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012174</value>
                  </attribute>
               </node>
               <node>
                  <name>Body-part</name>
                  <description>Any part of an organism.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012175</value>
                  </attribute>
                  <node>
                     <name>Head</name>
                     <description>The upper part of the human body, or the front or upper part of the body of an animal, typically separated from the rest of the body by a neck, and containing the brain, mouth, and sense organs.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012176</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Head-part</name>
                     <description>A part of the head.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013200</value>
                     </attribute>
                     <node>
                        <name>Brain</name>
                        <description>Organ inside the head that is made up of nerve cells and controls the body.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012177</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Brain-region</name>
                        <description>A region of the brain.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013201</value>
                        </attribute>
                        <node>
                           <name>Cerebellum</name>
                           <description>A major structure of the brain located near the brainstem. It plays a key role in motor control, coordination, precision, with contributions to different cognitive functions.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013202</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Frontal-lobe</name>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012178</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Occipital-lobe</name>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012179</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Parietal-lobe</name>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012180</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Temporal-lobe</name>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012181</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Ear</name>
                        <description>A sense organ needed for the detection of sound and for establishing balance.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012182</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Face</name>
                        <description>The anterior portion of the head extending from the forehead to the chin and ear to ear. The facial structures contain the eyes, nose and mouth, cheeks and jaws.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012183</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Face-part</name>
                        <description>A part of the face.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013203</value>
                        </attribute>
                        <node>
                           <name>Cheek</name>
                           <description>The fleshy part of the face bounded by the eyes, nose, ear, and jawline.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012184</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Chin</name>
                           <description>The part of the face below the lower lip and including the protruding part of the lower jaw.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012185</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Eye</name>
                           <description>The organ of sight or vision.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012186</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Eyebrow</name>
                           <description>The arched strip of hair on the bony ridge above each eye socket.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012187</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Eyelid</name>
                           <description>The folds of the skin that cover the eye when closed.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012188</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Forehead</name>
                           <description>The part of the face between the eyebrows and the normal hairline.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012189</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Lip</name>
                           <description>Fleshy fold which surrounds the opening of the mouth.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012190</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Mouth</name>
                           <description>The proximal portion of the digestive tract, containing the oral cavity and bounded by the oral opening.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012191</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Mouth-part</name>
                           <description>A part of the mouth.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013204</value>
                           </attribute>
                           <node>
                              <name>Teeth</name>
                              <description>The hard bone-like structures in the jaws. A collection of teeth arranged in some pattern in the mouth or other part of the body.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012193</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Tongue</name>
                              <description>A muscular organ in the mouth with significant role in mastication, swallowing, speech, and taste.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013205</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Nose</name>
                           <description>A structure of special sense serving as an organ of the sense of smell and as an entrance to the respiratory tract.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012192</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Hair</name>
                        <description>The filamentous outgrowth of the epidermis.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012194</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Lower-extremity</name>
                     <description>Refers to the whole inferior limb (leg and/or foot).</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012195</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Lower-extremity-part</name>
                     <description>A part of the lower extremity.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013206</value>
                     </attribute>
                     <node>
                        <name>Ankle</name>
                        <description>A gliding joint between the distal ends of the tibia and fibula and the proximal end of the talus.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012196</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Foot</name>
                        <description>The structure found below the ankle joint required for locomotion.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012198</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Foot-part</name>
                        <description>A part of the foot.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013207</value>
                        </attribute>
                        <node>
                           <name>Heel</name>
                           <description>The back of the foot below the ankle.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012200</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Instep</name>
                           <description>The part of the foot between the ball and the heel on the inner side.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012201</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Toe</name>
                           <description>A digit of the foot.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013208</value>
                           </attribute>
                           <node>
                              <name>Big-toe</name>
                              <description>The largest toe on the inner side of the foot.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012199</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Little-toe</name>
                              <description>The smallest toe located on the outer side of the foot.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012202</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Toes</name>
                           <description>The terminal digits of the foot. Used to describe collective attributes of all toes, such as bending all toes</description>
                           <attribute>
                              <name>relatedTag</name>
                              <value>Toe</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012203</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Knee</name>
                        <description>A joint connecting the lower part of the femur with the upper part of the tibia.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012204</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Lower-leg</name>
                        <description>The part of the leg between the knee and the ankle.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013209</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Lower-leg-part</name>
                        <description>A part of the lower leg.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013210</value>
                        </attribute>
                        <node>
                           <name>Calf</name>
                           <description>The fleshy part at the back of the leg below the knee.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012197</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Shin</name>
                           <description>Front part of the leg below the knee.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012205</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Upper-leg</name>
                        <description>The part of the leg between the hip and the knee.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013211</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Upper-leg-part</name>
                        <description>A part of the upper leg.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013212</value>
                        </attribute>
                        <node>
                           <name>Thigh</name>
                           <description>Upper part of the leg between hip and knee.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012206</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Neck</name>
                     <description>The part of the body connecting the head to the torso, containing the cervical spine and vital pathways of nerves, blood vessels, and the airway.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013213</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Torso</name>
                     <description>The body excluding the head and neck and limbs.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012207</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Torso-part</name>
                     <description>A part of the torso.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013214</value>
                     </attribute>
                     <node>
                        <name>Abdomen</name>
                        <description>The part of the body between the thorax and the pelvis.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013215</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Navel</name>
                        <description>The central mark on the abdomen created by the detachment of the umbilical cord after birth.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013216</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Pelvis</name>
                        <description>The bony structure at the base of the spine supporting the legs.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013217</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Pelvis-part</name>
                        <description>A part of the pelvis.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013218</value>
                        </attribute>
                        <node>
                           <name>Buttocks</name>
                           <description>The round fleshy parts that form the lower rear area of a human trunk.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012208</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Genitalia</name>
                           <description>The external organs of reproduction and urination, located in the pelvic region. This includes both male and female genital structures.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013219</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Gentalia</name>
                           <description>The external organs of reproduction. Deprecated due to spelling error. Use Genitalia.</description>
                           <attribute>
                              <name>deprecatedFrom</name>
                              <value>8.1.0</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012209</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Hip</name>
                           <description>The lateral prominence of the pelvis from the waist to the thigh.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012210</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Torso-back</name>
                        <description>The rear surface of the human body from the shoulders to the hips.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012211</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Torso-chest</name>
                        <description>The anterior side of the thorax from the neck to the abdomen.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012212</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Viscera</name>
                        <description>Internal organs of the body.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012213</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Waist</name>
                        <description>The abdominal circumference at the navel.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012214</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Upper-extremity</name>
                     <description>Refers to the whole superior limb (shoulder, arm, elbow, wrist, hand).</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012215</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Upper-extremity-part</name>
                     <description>A part of the upper extremity.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013220</value>
                     </attribute>
                     <node>
                        <name>Elbow</name>
                        <description>A type of hinge joint located between the forearm and upper arm.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012216</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Forearm</name>
                        <description>Lower part of the arm between the elbow and wrist.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012217</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Forearm-part</name>
                        <description>A part of the forearm.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013221</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Hand</name>
                        <description>The distal portion of the upper extremity. It consists of the carpus, metacarpus, and digits.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012218</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Hand-part</name>
                        <description>A part of the hand.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013222</value>
                        </attribute>
                        <node>
                           <name>Finger</name>
                           <description>Any of the digits of the hand.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012219</value>
                           </attribute>
                           <node>
                              <name>Index-finger</name>
                              <description>The second finger from the radial side of the hand, next to the thumb.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012220</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Little-finger</name>
                              <description>The fifth and smallest finger from the radial side of the hand.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012221</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Middle-finger</name>
                              <description>The middle or third finger from the radial side of the hand.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012222</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Ring-finger</name>
                              <description>The fourth finger from the radial side of the hand.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012223</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Thumb</name>
                              <description>The thick and short hand digit which is next to the index finger in humans.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012224</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Fingers</name>
                           <description>The terminal digits of the hand. Used to describe collective attributes of all fingers, such as bending all fingers</description>
                           <attribute>
                              <name>relatedTag</name>
                              <value>Finger</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013223</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Knuckles</name>
                           <description>A part of a finger at a joint where the bone is near the surface, especially where the finger joins the hand.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012225</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Palm</name>
                           <description>The part of the inner surface of the hand that extends from the wrist to the bases of the fingers.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012226</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Shoulder</name>
                        <description>Joint attaching upper arm to trunk.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012227</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Upper-arm</name>
                        <description>Portion of arm between shoulder and elbow.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012228</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Upper-arm-part</name>
                        <description>A part of the upper arm.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013224</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Wrist</name>
                        <description>A joint between the distal end of the radius and the proximal row of carpal bones.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012229</value>
                        </attribute>
                     </node>
                  </node>
               </node>
            </node>
            <node>
               <name>Organism</name>
               <description>A living entity, more specifically a biological entity that consists of one or more cells and is capable of genomic replication (independently or not).</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012230</value>
               </attribute>
               <node>
                  <name>Animal</name>
                  <description>A living organism that has membranous cell walls, requires oxygen and organic foods, and is capable of voluntary movement.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012231</value>
                  </attribute>
               </node>
               <node>
                  <name>Human</name>
                  <description>The bipedal primate mammal Homo sapiens.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012232</value>
                  </attribute>
               </node>
               <node>
                  <name>Plant</name>
                  <description>Any living organism that typically synthesizes its food from inorganic substances and possesses cellulose cell walls.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012233</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Language-item</name>
            <description>An entity related to a systematic means of communicating by the use of sounds, symbols, or gestures.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Sensory-presentation</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012234</value>
            </attribute>
            <node>
               <name>Character</name>
               <description>A mark or symbol used in writing.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012235</value>
               </attribute>
            </node>
            <node>
               <name>Clause</name>
               <description>A unit of grammatical organization next below the sentence in rank, usually consisting of a subject and predicate.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012236</value>
               </attribute>
            </node>
            <node>
               <name>Glyph</name>
               <description>A hieroglyphic character, symbol, or pictograph.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012237</value>
               </attribute>
            </node>
            <node>
               <name>Nonword</name>
               <description>An unpronounceable group of letters or speech sounds that is surrounded by white space when written, is not accepted as a word by native speakers.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012238</value>
               </attribute>
            </node>
            <node>
               <name>Paragraph</name>
               <description>A distinct section of a piece of writing, usually dealing with a single theme.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012239</value>
               </attribute>
            </node>
            <node>
               <name>Phoneme</name>
               <description>Any of the minimally distinct units of sound in a specified language that distinguish one word from another.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012240</value>
               </attribute>
            </node>
            <node>
               <name>Phrase</name>
               <description>A phrase is a group of words functioning as a single unit in the syntax of a sentence.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012241</value>
               </attribute>
            </node>
            <node>
               <name>Pseudoword</name>
               <description>A pronounceable group of letters or speech sounds that looks or sounds like a word but that is not accepted as such by native speakers.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012242</value>
               </attribute>
            </node>
            <node>
               <name>Sentence</name>
               <description>A set of words that is complete in itself, conveying a statement, question, exclamation, or command and typically containing an explicit or implied subject and a predicate containing a finite verb.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012243</value>
               </attribute>
            </node>
            <node>
               <name>Syllable</name>
               <description>A unit of pronunciation having a vowel or consonant sound, with or without surrounding consonants, forming the whole or a part of a word.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012244</value>
               </attribute>
            </node>
            <node>
               <name>Textblock</name>
               <description>A block of text.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012245</value>
               </attribute>
            </node>
            <node>
               <name>Word</name>
               <description>A single distinct meaningful element of speech or writing, used with others (or sometimes alone) to form a sentence and typically surrounded by white space when written or printed.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012246</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Object</name>
            <description>Something perceptible by one or more of the senses, especially by vision or touch. A material thing.</description>
            <attribute>
               <name>suggestedTag</name>
               <value>Sensory-presentation</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012247</value>
            </attribute>
            <node>
               <name>Geometric-object</name>
               <description>An object or a representation that has structure and topology in space.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012248</value>
               </attribute>
               <node>
                  <name>2D-shape</name>
                  <description>A planar, two-dimensional shape.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012249</value>
                  </attribute>
                  <node>
                     <name>Arrow</name>
                     <description>A shape with a pointed end indicating direction.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012250</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Clockface</name>
                     <description>The dial face of a clock. A location identifier based on clock-face-position numbering or anatomic subregion.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012251</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Cross</name>
                     <description>A figure or mark formed by two intersecting lines crossing at their midpoints.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012252</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Dash</name>
                     <description>A horizontal stroke in writing or printing to mark a pause or break in sense or to represent omitted letters or words.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012253</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Ellipse</name>
                     <description>A closed plane curve resulting from the intersection of a circular cone and a plane cutting completely through it, especially a plane not parallel to the base.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012254</value>
                     </attribute>
                     <node>
                        <name>Circle</name>
                        <description>A ring-shaped structure with every point equidistant from the center.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012255</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Rectangle</name>
                     <description>A parallelogram with four right angles.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012256</value>
                     </attribute>
                     <node>
                        <name>Square</name>
                        <description>A square is a special rectangle with four equal sides.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012257</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Single-point</name>
                     <description>A point is a geometric entity that is located in a zero-dimensional spatial region and whose position is defined by its coordinates in some coordinate system.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012258</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Star</name>
                     <description>A conventional or stylized representation of a star, typically one having five or more points.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012259</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Triangle</name>
                     <description>A three-sided polygon.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012260</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>3D-shape</name>
                  <description>A geometric three-dimensional shape.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012261</value>
                  </attribute>
                  <node>
                     <name>Box</name>
                     <description>A square or rectangular vessel, usually made of cardboard or plastic.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012262</value>
                     </attribute>
                     <node>
                        <name>Cube</name>
                        <description>A solid or semi-solid in the shape of a three dimensional square.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012263</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Cone</name>
                     <description>A shape whose base is a circle and whose sides taper up to a point.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012264</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Cylinder</name>
                     <description>A surface formed by circles of a given radius that are contained in a plane perpendicular to a given axis, whose centers align on the axis.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012265</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Ellipsoid</name>
                     <description>A closed plane curve resulting from the intersection of a circular cone and a plane cutting completely through it, especially a plane not parallel to the base.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012266</value>
                     </attribute>
                     <node>
                        <name>Sphere</name>
                        <description>A solid or hollow three-dimensional object bounded by a closed surface such that every point on the surface is equidistant from the center.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012267</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Pyramid</name>
                     <description>A polyhedron of which one face is a polygon of any number of sides, and the other faces are triangles with a common vertex.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012268</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Pattern</name>
                  <description>An arrangement of objects, facts, behaviors, or other things which have scientific, mathematical, geometric, statistical, or other meaning.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012269</value>
                  </attribute>
                  <node>
                     <name>Dots</name>
                     <description>A small round mark or spot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012270</value>
                     </attribute>
                  </node>
                  <node>
                     <name>LED-pattern</name>
                     <description>A pattern created by lighting selected members of a fixed light emitting diode array.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012271</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Ingestible-object</name>
               <description>Something that can be taken into the body by the mouth for digestion or absorption.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012272</value>
               </attribute>
            </node>
            <node>
               <name>Man-made-object</name>
               <description>Something constructed by human means.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012273</value>
               </attribute>
               <node>
                  <name>Building</name>
                  <description>A structure that has a roof and walls and stands more or less permanently in one place.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012274</value>
                  </attribute>
                  <node>
                     <name>Attic</name>
                     <description>A room or a space immediately below the roof of a building.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012275</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Basement</name>
                     <description>The part of a building that is wholly or partly below ground level.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012276</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Entrance</name>
                     <description>The means or place of entry.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012277</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Roof</name>
                     <description>A roof is the covering on the uppermost part of a building which provides protection from animals and weather, notably rain, but also heat, wind and sunlight.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012278</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Room</name>
                     <description>An area within a building enclosed by walls and floor and ceiling.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012279</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Clothing</name>
                  <description>A covering designed to be worn on the body.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012280</value>
                  </attribute>
               </node>
               <node>
                  <name>Device</name>
                  <description>An object contrived for a specific purpose.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012281</value>
                  </attribute>
                  <node>
                     <name>Assistive-device</name>
                     <description>A device that help an individual accomplish a task.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012282</value>
                     </attribute>
                     <node>
                        <name>Glasses</name>
                        <description>Frames with lenses worn in front of the eye for vision correction, eye protection, or protection from UV rays.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012283</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Writing-device</name>
                        <description>A device used for writing.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012284</value>
                        </attribute>
                        <node>
                           <name>Pen</name>
                           <description>A common writing instrument used to apply ink to a surface for writing or drawing.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012285</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Pencil</name>
                           <description>An implement for writing or drawing that is constructed of a narrow solid pigment core in a protective casing that prevents the core from being broken or marking the hand.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012286</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Computing-device</name>
                     <description>An electronic device which take inputs and processes results from the inputs.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012287</value>
                     </attribute>
                     <node>
                        <name>Cellphone</name>
                        <description>A telephone with access to a cellular radio system so it can be used over a wide area, without a physical connection to a network.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012288</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Desktop-computer</name>
                        <description>A computer suitable for use at an ordinary desk.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012289</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Laptop-computer</name>
                        <description>A computer that is portable and suitable for use while traveling.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012290</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Tablet-computer</name>
                        <description>A small portable computer that accepts input directly on to its screen rather than via a keyboard or mouse.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012291</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Engine</name>
                     <description>A motor is a machine designed to convert one or more forms of energy into mechanical energy.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012292</value>
                     </attribute>
                  </node>
                  <node>
                     <name>IO-device</name>
                     <description>Hardware used by a human (or other system) to communicate with a computer.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012293</value>
                     </attribute>
                     <node>
                        <name>Input-device</name>
                        <description>A piece of equipment used to provide data and control signals to an information processing system such as a computer or information appliance.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012294</value>
                        </attribute>
                        <node>
                           <name>Computer-mouse</name>
                           <description>A hand-held pointing device that detects two-dimensional motion relative to a surface.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012295</value>
                           </attribute>
                           <node>
                              <name>Mouse-button</name>
                              <description>An electric switch on a computer mouse which can be pressed or clicked to select or interact with an element of a graphical user interface.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012296</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Scroll-wheel</name>
                              <description>A scroll wheel or mouse wheel is a wheel used for scrolling made of hard plastic with a rubbery surface usually located between the left and right mouse buttons and is positioned perpendicular to the mouse surface.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012297</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Joystick</name>
                           <description>A control device that uses a movable handle to create two-axis input for a computer device.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012298</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Keyboard</name>
                           <description>A device consisting of mechanical keys that are pressed to create input to a computer.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012299</value>
                           </attribute>
                           <node>
                              <name>Keyboard-key</name>
                              <description>A button on a keyboard usually representing letters, numbers, functions, or symbols.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012300</value>
                              </attribute>
                              <node>
                                 <name>#</name>
                                 <description>Value of a keyboard key.</description>
                                 <attribute>
                                    <name>takesValue</name>
                                 </attribute>
                                 <attribute>
                                    <name>hedId</name>
                                    <value>HED_0012301</value>
                                 </attribute>
                              </node>
                           </node>
                        </node>
                        <node>
                           <name>Keypad</name>
                           <description>A device consisting of keys, usually in a block arrangement, that provides limited input to a system.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012302</value>
                           </attribute>
                           <node>
                              <name>Keypad-key</name>
                              <description>A key on a separate section of a computer keyboard that groups together numeric keys and those for mathematical or other special functions in an arrangement like that of a calculator.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012303</value>
                              </attribute>
                              <node>
                                 <name>#</name>
                                 <description>Value of keypad key.</description>
                                 <attribute>
                                    <name>takesValue</name>
                                 </attribute>
                                 <attribute>
                                    <name>hedId</name>
                                    <value>HED_0012304</value>
                                 </attribute>
                              </node>
                           </node>
                        </node>
                        <node>
                           <name>Microphone</name>
                           <description>A device designed to convert sound to an electrical signal.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012305</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Push-button</name>
                           <description>A switch designed to be operated by pressing a button.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012306</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Output-device</name>
                        <description>Any piece of computer hardware equipment which converts information into human understandable form.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012307</value>
                        </attribute>
                        <node>
                           <name>Auditory-device</name>
                           <description>A device designed to produce sound.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012308</value>
                           </attribute>
                           <node>
                              <name>Headphones</name>
                              <description>An instrument that consists of a pair of small loudspeakers, or less commonly a single speaker, held close to ears and connected to a signal source such as an audio amplifier, radio, CD player or portable media player.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012309</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Loudspeaker</name>
                              <description>A device designed to convert electrical signals to sounds that can be heard.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012310</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Display-device</name>
                           <description>An output device for presentation of information in visual or tactile form the latter used for example in tactile electronic displays for blind people.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012311</value>
                           </attribute>
                           <node>
                              <name>Computer-screen</name>
                              <description>An electronic device designed as a display or a physical device designed to be a protective mesh work.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012312</value>
                              </attribute>
                              <node>
                                 <name>Screen-window</name>
                                 <description>A part of a computer screen that contains a display different from the rest of the screen. A window is a graphical control element consisting of a visual area containing some of the graphical user interface of the program it belongs to and is framed by a window decoration.</description>
                                 <attribute>
                                    <name>hedId</name>
                                    <value>HED_0012313</value>
                                 </attribute>
                              </node>
                           </node>
                           <node>
                              <name>Head-mounted-display</name>
                              <description>An instrument that functions as a display device, worn on the head or as part of a helmet, that has a small display optic in front of one (monocular HMD) or each eye (binocular HMD).</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012314</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LED-display</name>
                              <description>A LED display is a flat panel display that uses an array of light-emitting diodes as pixels for a video display.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012315</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Recording-device</name>
                        <description>A device that copies information in a signal into a persistent information bearer.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012316</value>
                        </attribute>
                        <node>
                           <name>EEG-recorder</name>
                           <description>A device for recording electric currents in the brain using electrodes applied to the scalp, to the surface of the brain, or placed within the substance of the brain.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012317</value>
                           </attribute>
                        </node>
                        <node>
                           <name>EMG-recorder</name>
                           <description>A device for recording electrical activity of muscles using electrodes on the body surface or within the muscular mass.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013225</value>
                           </attribute>
                        </node>
                        <node>
                           <name>File-storage</name>
                           <description>A device for recording digital information to a permanent media.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012318</value>
                           </attribute>
                        </node>
                        <node>
                           <name>MEG-recorder</name>
                           <description>A device for measuring the magnetic fields produced by electrical activity in the brain, usually conducted externally.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012319</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Motion-capture</name>
                           <description>A device for recording the movement of objects or people.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012320</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Tape-recorder</name>
                           <description>A device for recording and reproduction usually using magnetic tape for storage that can be saved and played back.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012321</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Touchscreen</name>
                        <description>A control component that operates an electronic device by pressing the display on the screen.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012322</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Machine</name>
                     <description>A human-made device that uses power to apply forces and control movement to perform an action.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012323</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Measurement-device</name>
                     <description>A device that measures something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012324</value>
                     </attribute>
                     <node>
                        <name>Clock</name>
                        <description>A device designed to indicate the time of day or to measure the time duration of an event or action.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012325</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Robot</name>
                     <description>A mechanical device that sometimes resembles a living animal and is capable of performing a variety of often complex human tasks on command or by being programmed in advance.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012327</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tool</name>
                     <description>A component that is not part of a device but is designed to support its assembly or operation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012328</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Document</name>
                  <description>A physical object, or electronic counterpart, that is characterized by containing writing which is meant to be human-readable.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012329</value>
                  </attribute>
                  <node>
                     <name>Book</name>
                     <description>A volume made up of pages fastened along one edge and enclosed between protective covers.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012330</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Letter</name>
                     <description>A written message addressed to a person or organization.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012331</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Note</name>
                     <description>A brief written record.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012332</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Notebook</name>
                     <description>A book for notes or memoranda.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012333</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Questionnaire</name>
                     <description>A document consisting of questions and possibly responses, depending on whether it has been filled out.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012334</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Furnishing</name>
                  <description>Furniture, fittings, and other decorative accessories, such as curtains and carpets, for a house or room.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012335</value>
                  </attribute>
               </node>
               <node>
                  <name>Manufactured-material</name>
                  <description>Substances created or extracted from raw materials.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012336</value>
                  </attribute>
                  <node>
                     <name>Ceramic</name>
                     <description>A hard, brittle, heat-resistant and corrosion-resistant material made by shaping and then firing a nonmetallic mineral, such as clay, at a high temperature.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012337</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Glass</name>
                     <description>A brittle transparent solid with irregular atomic structure.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012338</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Paper</name>
                     <description>A thin sheet material produced by mechanically or chemically processing cellulose fibres derived from wood, rags, grasses or other vegetable sources in water.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012339</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Plastic</name>
                     <description>Various high-molecular-weight thermoplastic or thermo-setting polymers that are capable of being molded, extruded, drawn, or otherwise shaped and then hardened into a form.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012340</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Steel</name>
                     <description>An alloy made up of iron with typically a few tenths of a percent of carbon to improve its strength and fracture resistance compared to iron.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012341</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Media</name>
                  <description>Media are audio/visual/audiovisual modes of communicating information for mass consumption.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012342</value>
                  </attribute>
                  <node>
                     <name>Media-clip</name>
                     <description>A short segment of media.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012343</value>
                     </attribute>
                     <node>
                        <name>Audio-clip</name>
                        <description>A short segment of audio.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012344</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Audiovisual-clip</name>
                        <description>A short media segment containing both audio and video.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012345</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Video-clip</name>
                        <description>A short segment of video.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012346</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Visualization</name>
                     <description>An planned process that creates images, diagrams or animations from the input data.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012347</value>
                     </attribute>
                     <node>
                        <name>Animation</name>
                        <description>A form of graphical illustration that changes with time to give a sense of motion or represent dynamic changes in the portrayal.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012348</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Art-installation</name>
                        <description>A large-scale, mixed-media constructions, often designed for a specific place or for a temporary period of time.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012349</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Braille</name>
                        <description>A display using a system of raised dots that can be read with the fingers by people who are blind.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012350</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Image</name>
                        <description>Any record of an imaging event whether physical or electronic.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012351</value>
                        </attribute>
                        <node>
                           <name>Cartoon</name>
                           <description>A type of illustration, sometimes animated, typically in a non-realistic or semi-realistic style. The specific meaning has evolved over time, but the modern usage usually refers to either an image or series of images intended for satire, caricature, or humor. A motion picture that relies on a sequence of illustrations for its animation.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012352</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Drawing</name>
                           <description>A representation of an object or outlining a figure, plan, or sketch by means of lines.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012353</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Icon</name>
                           <description>A sign (such as a word or graphic symbol) whose form suggests its meaning.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012354</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Painting</name>
                           <description>A work produced through the art of painting.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012355</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Photograph</name>
                           <description>An image recorded by a camera.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012356</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Movie</name>
                        <description>A sequence of images displayed in succession giving the illusion of continuous movement.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012357</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Outline-visualization</name>
                        <description>A visualization consisting of a line or set of lines enclosing or indicating the shape of an object in a sketch or diagram.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012358</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Point-light-visualization</name>
                        <description>A display in which action is depicted using a few points of light, often generated from discrete sensors in motion capture.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012359</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Sculpture</name>
                        <description>A two- or three-dimensional representative or abstract forms, especially by carving stone or wood or by casting metal or plaster.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012360</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Stick-figure-visualization</name>
                        <description>A drawing showing the head of a human being or animal as a circle and all other parts as straight lines.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012361</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Navigational-object</name>
                  <description>An object whose purpose is to assist directed movement from one location to another.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012362</value>
                  </attribute>
                  <node>
                     <name>Path</name>
                     <description>A trodden way. A way or track laid down for walking or made by continual treading.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012363</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Road</name>
                     <description>An open way for the passage of vehicles, persons, or animals on land.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012364</value>
                     </attribute>
                     <node>
                        <name>Lane</name>
                        <description>A defined path with physical dimensions through which an object or substance may traverse.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012365</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Runway</name>
                     <description>A paved strip of ground on a landing field for the landing and takeoff of aircraft.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012366</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Vehicle</name>
                  <description>A mobile machine which transports people or cargo.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012367</value>
                  </attribute>
                  <node>
                     <name>Aircraft</name>
                     <description>A vehicle which is able to travel through air in an atmosphere.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012368</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Bicycle</name>
                     <description>A human-powered, pedal-driven, single-track vehicle, having two wheels attached to a frame, one behind the other.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012369</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Boat</name>
                     <description>A watercraft of any size which is able to float or plane on water.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012370</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Car</name>
                     <description>A wheeled motor vehicle used primarily for the transportation of human passengers.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012371</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Cart</name>
                     <description>A cart is a vehicle which has two wheels and is designed to transport human passengers or cargo.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012372</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tractor</name>
                     <description>A mobile machine specifically designed to deliver a high tractive effort at slow speeds, and mainly used for the purposes of hauling a trailer or machinery used in agriculture or construction.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012373</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Train</name>
                     <description>A connected line of railroad cars with or without a locomotive.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012374</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Truck</name>
                     <description>A motor vehicle which, as its primary function, transports cargo rather than human passengers.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012375</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Natural-object</name>
               <description>Something that exists in or is produced by nature, and is not artificial or man-made.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012376</value>
               </attribute>
               <node>
                  <name>Mineral</name>
                  <description>A solid, homogeneous, inorganic substance occurring in nature and having a definite chemical composition.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012377</value>
                  </attribute>
               </node>
               <node>
                  <name>Natural-feature</name>
                  <description>A feature that occurs in nature. A prominent or identifiable aspect, region, or site of interest.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012378</value>
                  </attribute>
                  <node>
                     <name>Field</name>
                     <description>An unbroken expanse as of ice or grassland.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012379</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Hill</name>
                     <description>A rounded elevation of limited extent rising above the surrounding land with local relief of less than 300m.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012380</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Mountain</name>
                     <description>A landform that extends above the surrounding terrain in a limited area.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012381</value>
                     </attribute>
                  </node>
                  <node>
                     <name>River</name>
                     <description>A natural freshwater surface stream of considerable volume and a permanent or seasonal flow, moving in a definite channel toward a sea, lake, or another river.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012382</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Waterfall</name>
                     <description>A sudden descent of water over a step or ledge in the bed of a river.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012383</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Sound</name>
            <description>Mechanical vibrations transmitted by an elastic medium. Something that can be heard.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012384</value>
            </attribute>
            <node>
               <name>Environmental-sound</name>
               <description>Sounds occurring in the environment. An accumulation of noise pollution that occurs outside. This noise can be caused by transport, industrial, and recreational activities.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012385</value>
               </attribute>
               <node>
                  <name>Crowd-sound</name>
                  <description>Noise produced by a mixture of sounds from a large group of people.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012386</value>
                  </attribute>
               </node>
               <node>
                  <name>Signal-noise</name>
                  <description>Any part of a signal that is not the true or original signal but is introduced by the communication mechanism.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012387</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Musical-sound</name>
               <description>Sound produced by continuous and regular vibrations, as opposed to noise.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012388</value>
               </attribute>
               <node>
                  <name>Instrument-sound</name>
                  <description>Sound produced by a musical instrument.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012389</value>
                  </attribute>
               </node>
               <node>
                  <name>Tone</name>
                  <description>A musical note, warble, or other sound used as a particular signal on a telephone or answering machine.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012390</value>
                  </attribute>
               </node>
               <node>
                  <name>Vocalized-sound</name>
                  <description>Musical sound produced by vocal cords in a biological agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012391</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Named-animal-sound</name>
               <description>A sound recognizable as being associated with particular animals.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012392</value>
               </attribute>
               <node>
                  <name>Barking</name>
                  <description>Sharp explosive cries like sounds made by certain animals, especially a dog, fox, or seal.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012393</value>
                  </attribute>
               </node>
               <node>
                  <name>Bleating</name>
                  <description>Wavering cries like sounds made by a sheep, goat, or calf.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012394</value>
                  </attribute>
               </node>
               <node>
                  <name>Chirping</name>
                  <description>Short, sharp, high-pitched noises like sounds made by small birds or an insects.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012395</value>
                  </attribute>
               </node>
               <node>
                  <name>Crowing</name>
                  <description>Loud shrill sounds characteristic of roosters.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012396</value>
                  </attribute>
               </node>
               <node>
                  <name>Growling</name>
                  <description>Low guttural sounds like those that made in the throat by a hostile dog or other animal.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012397</value>
                  </attribute>
               </node>
               <node>
                  <name>Meowing</name>
                  <description>Vocalizations like those made by as those cats. These sounds have diverse tones and are sometimes chattered, murmured or whispered. The purpose can be assertive.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012398</value>
                  </attribute>
               </node>
               <node>
                  <name>Mooing</name>
                  <description>Deep vocal sounds like those made by a cow.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012399</value>
                  </attribute>
               </node>
               <node>
                  <name>Purring</name>
                  <description>Low continuous vibratory sound such as those made by cats. The sound expresses contentment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012400</value>
                  </attribute>
               </node>
               <node>
                  <name>Roaring</name>
                  <description>Loud, deep, or harsh prolonged sounds such as those made by big cats and bears for long-distance communication and intimidation.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012401</value>
                  </attribute>
               </node>
               <node>
                  <name>Squawking</name>
                  <description>Loud, harsh noises such as those made by geese.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012402</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Named-object-sound</name>
               <description>A sound identifiable as coming from a particular type of object.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012403</value>
               </attribute>
               <node>
                  <name>Alarm-sound</name>
                  <description>A loud signal often loud continuous ringing to alert people to a problem or condition that requires urgent attention.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012404</value>
                  </attribute>
               </node>
               <node>
                  <name>Beep</name>
                  <description>A short, single tone, that is typically high-pitched and generally made by a computer or other machine.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012405</value>
                  </attribute>
               </node>
               <node>
                  <name>Buzz</name>
                  <description>A persistent vibratory sound often made by a buzzer device and used to indicate something incorrect.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012406</value>
                  </attribute>
               </node>
               <node>
                  <name>Click</name>
                  <description>The sound made by a mechanical cash register, often to designate a reward.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012407</value>
                  </attribute>
               </node>
               <node>
                  <name>Ding</name>
                  <description>A short ringing sound such as that made by a bell, often to indicate a correct response or the expiration of time.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012408</value>
                  </attribute>
               </node>
               <node>
                  <name>Horn-blow</name>
                  <description>A loud sound made by forcing air through a sound device that funnels air to create the sound, often used to sound an alert.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012409</value>
                  </attribute>
               </node>
               <node>
                  <name>Ka-ching</name>
                  <description>The sound made by a mechanical cash register, often to designate a reward.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012410</value>
                  </attribute>
               </node>
               <node>
                  <name>Siren</name>
                  <description>A loud, continuous sound often varying in frequency designed to indicate an emergency.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012411</value>
                  </attribute>
               </node>
            </node>
         </node>
      </node>
      <node>
         <name>Property</name>
         <description>Something that pertains to a thing. A characteristic of some entity. A quality or feature regarded as a characteristic or inherent part of someone or something. HED attributes are adjectives or adverbs.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0012412</value>
         </attribute>
         <node>
            <name>Agent-property</name>
            <description>Something that pertains to or describes an agent.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012413</value>
            </attribute>
            <node>
               <name>Agent-state</name>
               <description>The state of the agent.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012414</value>
               </attribute>
               <node>
                  <name>Agent-cognitive-state</name>
                  <description>The state of the cognitive processes or state of mind of the agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012415</value>
                  </attribute>
                  <node>
                     <name>Alert</name>
                     <description>Condition of heightened watchfulness or preparation for action.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012416</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Anesthetized</name>
                     <description>Having lost sensation to pain or having senses dulled due to the effects of an anesthetic.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012417</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Asleep</name>
                     <description>Having entered a periodic, readily reversible state of reduced awareness and metabolic activity, usually accompanied by physical relaxation and brain activity.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012418</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Attentive</name>
                     <description>Concentrating and focusing mental energy on the task or surroundings.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012419</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Awake</name>
                     <description>In a non sleeping state.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012420</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Brain-dead</name>
                     <description>Characterized by the irreversible absence of cortical and brain stem functioning.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012421</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Comatose</name>
                     <description>In a state of profound unconsciousness associated with markedly depressed cerebral activity.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012422</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Distracted</name>
                     <description>Lacking in concentration because of being preoccupied.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012423</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Drowsy</name>
                     <description>In a state of near-sleep, a strong desire for sleep, or sleeping for unusually long periods.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012424</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Intoxicated</name>
                     <description>In a state with disturbed psychophysiological functions and responses as a result of administration or ingestion of a psychoactive substance.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012425</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Locked-in</name>
                     <description>In a state of complete paralysis of all voluntary muscles except for the ones that control the movements of the eyes.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012426</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Passive</name>
                     <description>Not responding or initiating an action in response to a stimulus.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012427</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Resting</name>
                     <description>A state in which the agent is not exhibiting any physical exertion.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012428</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Vegetative</name>
                     <description>A state of wakefulness and conscience, but (in contrast to coma) with involuntary opening of the eyes and movements (such as teeth grinding, yawning, or thrashing of the extremities).</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012429</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-emotional-state</name>
                  <description>The status of the general temperament and outlook of an agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012430</value>
                  </attribute>
                  <node>
                     <name>Angry</name>
                     <description>Experiencing emotions characterized by marked annoyance or hostility.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012431</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Aroused</name>
                     <description>In a state reactive to stimuli leading to increased heart rate and blood pressure, sensory alertness, mobility and readiness to respond.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012432</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Awed</name>
                     <description>Filled with wonder. Feeling grand, sublime or powerful emotions characterized by a combination of joy, fear, admiration, reverence, and/or respect.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012433</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Compassionate</name>
                     <description>Feeling or showing sympathy and concern for others often evoked for a person who is in distress and associated with altruistic motivation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012434</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Content</name>
                     <description>Feeling satisfaction with things as they are.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012435</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Disgusted</name>
                     <description>Feeling revulsion or profound disapproval aroused by something unpleasant or offensive.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012436</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Emotionally-neutral</name>
                     <description>Feeling neither satisfied nor dissatisfied.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012437</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Empathetic</name>
                     <description>Understanding and sharing the feelings of another. Being aware of, being sensitive to, and vicariously experiencing the feelings, thoughts, and experience of another.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012438</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Excited</name>
                     <description>Feeling great enthusiasm and eagerness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012439</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Fearful</name>
                     <description>Feeling apprehension that one may be in danger.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012440</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Frustrated</name>
                     <description>Feeling annoyed as a result of being blocked, thwarted, disappointed or defeated.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012441</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Grieving</name>
                     <description>Feeling sorrow in response to loss, whether physical or abstract.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012442</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Happy</name>
                     <description>Feeling pleased and content.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012443</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Jealous</name>
                     <description>Feeling threatened by a rival in a relationship with another individual, in particular an intimate partner, usually involves feelings of threat, fear, suspicion, distrust, anxiety, anger, betrayal, and rejection.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012444</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Joyful</name>
                     <description>Feeling delight or intense happiness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012445</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Loving</name>
                     <description>Feeling a strong positive emotion of affection and attraction.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012446</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Relieved</name>
                     <description>No longer feeling pain, distress,anxiety, or reassured.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012447</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sad</name>
                     <description>Feeling grief or unhappiness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012448</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Stressed</name>
                     <description>Experiencing mental or emotional strain or tension.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012449</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-physiological-state</name>
                  <description>Having to do with the mechanical, physical, or biochemical function of an agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012450</value>
                  </attribute>
                  <node>
                     <name>Catamenial</name>
                     <description>Related to menstruation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013226</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Fever</name>
                     <description>Body temperature above the normal range.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Sick</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013227</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Healthy</name>
                     <description>Having no significant health-related issues.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Sick</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012451</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Hungry</name>
                     <description>Being in a state of craving or desiring food.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Sated</value>
                        <value>Thirsty</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012452</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Rested</name>
                     <description>Feeling refreshed and relaxed.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Tired</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012453</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sated</name>
                     <description>Feeling full.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Hungry</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012454</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sick</name>
                     <description>Being in a state of ill health, bodily malfunction, or discomfort.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Healthy</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012455</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Thirsty</name>
                     <description>Feeling a need to drink.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Hungry</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012456</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tired</name>
                     <description>Feeling in need of sleep or rest.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Rested</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012457</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-postural-state</name>
                  <description>Pertaining to the position in which agent holds their body.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012458</value>
                  </attribute>
                  <node>
                     <name>Crouching</name>
                     <description>Adopting a position where the knees are bent and the upper body is brought forward and down, sometimes to avoid detection or to defend oneself.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012459</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Eyes-closed</name>
                     <description>Keeping eyes closed with no blinking.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012460</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Eyes-open</name>
                     <description>Keeping eyes open with occasional blinking.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012461</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Kneeling</name>
                     <description>Positioned where one or both knees are on the ground.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012462</value>
                     </attribute>
                  </node>
                  <node>
                     <name>On-treadmill</name>
                     <description>Ambulation on an exercise apparatus with an endless moving belt to support moving in place.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012463</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Prone</name>
                     <description>Positioned in a recumbent body position whereby the person lies on its stomach and faces downward.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012464</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Seated-with-chin-rest</name>
                     <description>Using a device that supports the chin and head.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012465</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sitting</name>
                     <description>In a seated position.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012466</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Standing</name>
                     <description>Assuming or maintaining an erect upright position.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012467</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Agent-task-role</name>
               <description>The function or part that is ascribed to an agent in performing the task.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012468</value>
               </attribute>
               <node>
                  <name>Experiment-actor</name>
                  <description>An agent who plays a predetermined role to create the experiment scenario.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012469</value>
                  </attribute>
               </node>
               <node>
                  <name>Experiment-controller</name>
                  <description>An agent exerting control over some aspect of the experiment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012470</value>
                  </attribute>
               </node>
               <node>
                  <name>Experiment-participant</name>
                  <description>Someone who takes part in an activity related to an experiment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012471</value>
                  </attribute>
               </node>
               <node>
                  <name>Experimenter</name>
                  <description>Person who is the owner of the experiment and has its responsibility.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012472</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Agent-trait</name>
               <description>A genetically, environmentally, or socially determined characteristic of an agent.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012473</value>
               </attribute>
               <node>
                  <name>Age</name>
                  <description>Length of time elapsed time since birth of the agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012474</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012475</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Agent-experience-level</name>
                  <description>Amount of skill or knowledge that the agent has as pertains to the task.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012476</value>
                  </attribute>
                  <node>
                     <name>Expert-level</name>
                     <description>Having comprehensive and authoritative knowledge of or skill in a particular area related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Intermediate-experience-level</value>
                        <value>Novice-level</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012477</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Intermediate-experience-level</name>
                     <description>Having a moderate amount of knowledge or skill related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Expert-level</value>
                        <value>Novice-level</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012478</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Novice-level</name>
                     <description>Being inexperienced in a field or situation related to the task.</description>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Expert-level</value>
                        <value>Intermediate-experience-level</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012479</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Ethnicity</name>
                  <description>Belong to a social group that has a common national or cultural tradition. Use with Label to avoid extension.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012480</value>
                  </attribute>
               </node>
               <node>
                  <name>Gender</name>
                  <description>Characteristics that are socially constructed, including norms, behaviors, and roles based on sex.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012481</value>
                  </attribute>
               </node>
               <node>
                  <name>Handedness</name>
                  <description>Individual preference for use of a hand, known as the dominant hand.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012482</value>
                  </attribute>
                  <node>
                     <name>Ambidextrous</name>
                     <description>Having no overall dominance in the use of right or left hand or foot in the performance of tasks that require one hand or foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012483</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Left-handed</name>
                     <description>Preference for using the left hand or foot for tasks requiring the use of a single hand or foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012484</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Right-handed</name>
                     <description>Preference for using the right hand or foot for tasks requiring the use of a single hand or foot.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012485</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Race</name>
                  <description>Belonging to a group sharing physical or social qualities as defined within a specified society. Use with Label to avoid extension.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012486</value>
                  </attribute>
               </node>
               <node>
                  <name>Sex</name>
                  <description>Physical properties or qualities by which male is distinguished from female.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012487</value>
                  </attribute>
                  <node>
                     <name>Female</name>
                     <description>Biological sex of an individual with female sexual organs such ova.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012488</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Intersex</name>
                     <description>Having genitalia and/or secondary sexual characteristics of indeterminate sex.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012489</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Male</name>
                     <description>Biological sex of an individual with male sexual organs producing sperm.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012490</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Other-sex</name>
                     <description>A non-specific designation of sexual traits.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012491</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Data-property</name>
            <description>Something that pertains to data or information.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012492</value>
            </attribute>
            <node>
               <name>Data-artifact</name>
               <description>An anomalous, interfering, or distorting signal originating from a source other than the item being studied.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012493</value>
               </attribute>
               <node>
                  <name>Biological-artifact</name>
                  <description>A data artifact arising from a biological entity being measured.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012494</value>
                  </attribute>
                  <node>
                     <name>Chewing-artifact</name>
                     <description>Artifact from moving the jaw in a chewing motion.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012495</value>
                     </attribute>
                  </node>
                  <node>
                     <name>ECG-artifact</name>
                     <description>An electrical artifact from the far-field potential from pulsation of the heart, time locked to QRS complex.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012496</value>
                     </attribute>
                  </node>
                  <node>
                     <name>EMG-artifact</name>
                     <description>Artifact from muscle activity and myogenic potentials at the measurements site. In EEG, myogenic potentials are the most common artifacts. Frontalis and temporalis muscles (e.g. clenching of jaw muscles) are common causes. Generally, the potentials generated in the muscles are of shorter duration than those generated in the brain. The frequency components are usually beyond 30-50 Hz, and the bursts are arrhythmic.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012497</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Eye-artifact</name>
                     <description>Ocular movements and blinks can result in artifacts in different types of data. In electrophysiology data, these can result transients and offsets the signal.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012498</value>
                     </attribute>
                     <node>
                        <name>Eye-blink-artifact</name>
                        <description>Artifact from eye blinking. In EEG, Fp1/Fp2 electrodes become electro-positive with eye closure because the cornea is positively charged causing a negative deflection in Fp1/Fp2. If the eye blink is unilateral, consider prosthetic eye.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012499</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Eye-movement-artifact</name>
                        <description>Eye movements can cause artifacts on recordings. The charge of the eye can especially cause artifacts in electrophysiology data.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012500</value>
                        </attribute>
                        <node>
                           <name>Horizontal-eye-movement-artifact</name>
                           <description>Artifact from moving eyes left-to-right and right-to-left. In EEG, there is an upward deflection in the Fp2-F8 derivation, when the eyes move to the right side. In this case F8 becomes more positive and therefore. When the eyes move to the left, F7 becomes more positive and there is an upward deflection in the Fp1-F7 derivation.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012501</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Nystagmus-artifact</name>
                           <description>Artifact from nystagmus (a vision condition in which the eyes make repetitive, uncontrolled movements).</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012502</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Slow-eye-movement-artifact</name>
                           <description>Artifacts originating from slow, rolling eye-movements, seen during drowsiness.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012503</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Vertical-eye-movement-artifact</name>
                           <description>Artifact from moving eyes up and down. In EEG, this causes positive potentials (50-100 micro V) with bi-frontal distribution, maximum at Fp1 and Fp2, when the eyeball rotates upward. The downward rotation of the eyeball is associated with the negative deflection. The time course of the deflections is similar to the time course of the eyeball movement.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012504</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Movement-artifact</name>
                     <description>Artifact in the measured data generated by motion of the subject.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012505</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Pulse-artifact</name>
                     <description>A mechanical artifact from a pulsating blood vessel near a measurement site, cardio-ballistic artifact.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012506</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Respiration-artifact</name>
                     <description>Artifact from breathing.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012507</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Rocking-patting-artifact</name>
                     <description>Quasi-rhythmical artifacts in recordings most commonly seen in infants. Typically caused by a caregiver rocking or patting the infant.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012508</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sucking-artifact</name>
                     <description>Artifact from sucking, typically seen in very young cases.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012509</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sweat-artifact</name>
                     <description>Artifact from sweating. In EEG, this is a low amplitude undulating waveform that is usually greater than 2 seconds and may appear to be an unstable baseline.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012510</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tongue-movement-artifact</name>
                     <description>Artifact from tongue movement (Glossokinetic). The tongue functions as a dipole, with the tip negative with respect to the base. In EEG, the artifact produced by the tongue has a broad potential field that drops from frontal to occipital areas, although it is less steep than that produced by eye movement artifacts. The amplitude of the potentials is greater inferiorly than in parasagittal regions; the frequency is variable but usually in the delta range. Chewing and sucking can produce similar artifacts.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012511</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Nonbiological-artifact</name>
                  <description>A data artifact arising from a non-biological source.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012512</value>
                  </attribute>
                  <node>
                     <name>Artificial-ventilation-artifact</name>
                     <description>Artifact stemming from mechanical ventilation. These can occur at the same rate as the ventilator, but also have other patterns.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012513</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Dialysis-artifact</name>
                     <description>Artifacts seen in recordings during continuous renal replacement therapy (dialysis).</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012514</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Electrode-movement-artifact</name>
                     <description>Artifact from electrode movement.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012515</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Electrode-pops-artifact</name>
                     <description>Brief artifact with a steep rise and slow fall of an electrophysiological signal, most often caused by a loose electrode.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012516</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Induction-artifact</name>
                     <description>Artifacts induced by nearby equipment. In EEG, these are usually of high frequency.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012517</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Line-noise-artifact</name>
                     <description>Power line noise at 50 Hz or 60 Hz.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012518</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>frequencyUnits</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012519</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Salt-bridge-artifact</name>
                     <description>Artifact from salt-bridge between EEG electrodes.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012520</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-marker</name>
               <description>An indicator placed to mark something.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012521</value>
               </attribute>
               <node>
                  <name>Data-break-marker</name>
                  <description>An indicator place to indicate a gap in the data.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012522</value>
                  </attribute>
               </node>
               <node>
                  <name>Temporal-marker</name>
                  <description>An indicator placed at a particular time in the data.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012523</value>
                  </attribute>
                  <node>
                     <name>Inset</name>
                     <description>Marks an intermediate point in an ongoing event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Onset</value>
                        <value>Offset</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012524</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Offset</name>
                     <description>Marks the end of an event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Onset</value>
                        <value>Inset</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012525</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Onset</name>
                     <description>Marks the start of an ongoing event of temporal extent.</description>
                     <attribute>
                        <name>topLevelTagGroup</name>
                     </attribute>
                     <attribute>
                        <name>reserved</name>
                     </attribute>
                     <attribute>
                        <name>relatedTag</name>
                        <value>Inset</value>
                        <value>Offset</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012526</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Pause</name>
                     <description>Indicates the temporary interruption of the operation of a process and subsequently a wait for a signal to continue.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012527</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Time-out</name>
                     <description>A cancellation or cessation that automatically occurs when a predefined interval of time has passed without a certain event occurring.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012528</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Time-sync</name>
                     <description>A synchronization signal whose purpose is to help synchronize different signals or processes. Often used to indicate a marker inserted into the recorded data to allow post hoc synchronization of concurrently recorded data streams.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012529</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-resolution</name>
               <description>Smallest change in a quality being measured by an sensor that causes a perceptible change.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012530</value>
               </attribute>
               <node>
                  <name>Printer-resolution</name>
                  <description>Resolution of a printer, usually expressed as the number of dots-per-inch for a printer.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012531</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012532</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Screen-resolution</name>
                  <description>Resolution of a screen, usually expressed as the of pixels in a dimension for a digital display device.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012533</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012534</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Sensory-resolution</name>
                  <description>Resolution of measurements by a sensing device.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012535</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012536</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Spatial-resolution</name>
                  <description>Linear spacing of a spatial measurement.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012537</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012538</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Spectral-resolution</name>
                  <description>Measures the ability of a sensor to resolve features in the electromagnetic spectrum.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012539</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012540</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Temporal-resolution</name>
                  <description>Measures the ability of a sensor to resolve features in time.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012541</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>numericClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012542</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-source-type</name>
               <description>The type of place, person, or thing from which the data comes or can be obtained.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012543</value>
               </attribute>
               <node>
                  <name>Computed-feature</name>
                  <description>A feature computed from the data by a tool. This tag should be grouped with a label of the form Toolname_propertyName.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012544</value>
                  </attribute>
               </node>
               <node>
                  <name>Computed-prediction</name>
                  <description>A computed extrapolation of known data.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012545</value>
                  </attribute>
               </node>
               <node>
                  <name>Expert-annotation</name>
                  <description>An explanatory or critical comment or other in-context information provided by an authority.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012546</value>
                  </attribute>
               </node>
               <node>
                  <name>Instrument-measurement</name>
                  <description>Information obtained from a device that is used to measure material properties or make other observations.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012547</value>
                  </attribute>
               </node>
               <node>
                  <name>Observation</name>
                  <description>Active acquisition of information from a primary source. Should be grouped with a label of the form AgentID_featureName.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012548</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Data-value</name>
               <description>Designation of the type of a data item.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012549</value>
               </attribute>
               <node>
                  <name>Categorical-value</name>
                  <description>Indicates that something can take on a limited and usually fixed number of possible values.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012550</value>
                  </attribute>
                  <node>
                     <name>Categorical-class-value</name>
                     <description>Categorical values that fall into discrete classes such as true or false. The grouping is absolute in the sense that it is the same for all participants.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012551</value>
                     </attribute>
                     <node>
                        <name>All</name>
                        <description>To a complete degree or to the full or entire extent.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Some</value>
                           <value>None</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012552</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Correct</name>
                        <description>Free from error. Especially conforming to fact or truth.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Wrong</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012553</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Explicit</name>
                        <description>Stated clearly and in detail, leaving no room for confusion or doubt.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Implicit</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012554</value>
                        </attribute>
                     </node>
                     <node>
                        <name>False</name>
                        <description>Not in accordance with facts, reality or definitive criteria.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>True</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012555</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Implicit</name>
                        <description>Implied though not plainly expressed.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Explicit</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012556</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Invalid</name>
                        <description>Not allowed or not conforming to the correct format or specifications.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Valid</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012557</value>
                        </attribute>
                     </node>
                     <node>
                        <name>None</name>
                        <description>No person or thing, nobody, not any.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>All</value>
                           <value>Some</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012558</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Some</name>
                        <description>At least a small amount or number of, but not a large amount of, or often.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>All</value>
                           <value>None</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012559</value>
                        </attribute>
                     </node>
                     <node>
                        <name>True</name>
                        <description>Conforming to facts, reality or definitive criteria.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>False</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012560</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unknown</name>
                        <description>The information has not been provided.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Invalid</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012561</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Valid</name>
                        <description>Allowable, usable, or acceptable.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Invalid</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012562</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Wrong</name>
                        <description>Inaccurate or not correct.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Correct</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012563</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-judgment-value</name>
                     <description>Categorical values that are based on the judgment or perception of the participant such familiar and famous.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012564</value>
                     </attribute>
                     <node>
                        <name>Abnormal</name>
                        <description>Deviating in any way from the state, position, structure, condition, behavior, or rule which is considered a norm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Normal</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012565</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Asymmetrical</name>
                        <description>Lacking symmetry or having parts that fail to correspond to one another in shape, size, or arrangement.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Symmetrical</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012566</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Audible</name>
                        <description>A sound that can be perceived by the participant.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Inaudible</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012567</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Complex</name>
                        <description>Hard, involved or complicated, elaborate, having many parts.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Simple</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012568</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Congruent</name>
                        <description>Concordance of multiple evidence lines. In agreement or harmony.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Incongruent</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012569</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Constrained</name>
                        <description>Keeping something within particular limits or bounds.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unconstrained</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012570</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Disordered</name>
                        <description>Not neatly arranged. Confused and untidy. A structural quality in which the parts of an object are non-rigid.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Ordered</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012571</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Familiar</name>
                        <description>Recognized, familiar, or within the scope of knowledge.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unfamiliar</value>
                           <value>Famous</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012572</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Famous</name>
                        <description>A person who has a high degree of recognition by the general population for his or her success or accomplishments. A famous person.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Familiar</value>
                           <value>Unfamiliar</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012573</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Inaudible</name>
                        <description>A sound below the threshold of perception of the participant.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Audible</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012574</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Incongruent</name>
                        <description>Not in agreement or harmony.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Congruent</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012575</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Involuntary</name>
                        <description>An action that is not made by choice. In the body, involuntary actions (such as blushing) occur automatically, and cannot be controlled by choice.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Voluntary</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012576</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Masked</name>
                        <description>Information exists but is not provided or is partially obscured due to security,privacy, or other concerns.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Unmasked</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012577</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Normal</name>
                        <description>Being approximately average or within certain limits. Conforming with or constituting a norm or standard or level or type or social norm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Abnormal</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012578</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Ordered</name>
                        <description>Conforming to a logical or comprehensible arrangement of separate elements.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Disordered</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012579</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Simple</name>
                        <description>Easily understood or presenting no difficulties.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Complex</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012580</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Symmetrical</name>
                        <description>Made up of exactly similar parts facing each other or around an axis. Showing aspects of symmetry.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Asymmetrical</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012581</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unconstrained</name>
                        <description>Moving without restriction.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Constrained</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012582</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unfamiliar</name>
                        <description>Not having knowledge or experience of.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Familiar</value>
                           <value>Famous</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012583</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Unmasked</name>
                        <description>Information is revealed.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Masked</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012584</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Voluntary</name>
                        <description>Using free will or design; not forced or compelled; controlled by individual volition.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Involuntary</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012585</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-level-value</name>
                     <description>Categorical values based on dividing a continuous variable into levels such as high and low.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012586</value>
                     </attribute>
                     <node>
                        <name>Cold</name>
                        <description>Having an absence of heat.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Hot</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012587</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Deep</name>
                        <description>Extending relatively far inward or downward.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Shallow</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012588</value>
                        </attribute>
                     </node>
                     <node>
                        <name>High</name>
                        <description>Having a greater than normal degree, intensity, or amount.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Low</value>
                           <value>Medium</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012589</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Hot</name>
                        <description>Having an excess of heat.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Cold</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012590</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Large</name>
                        <description>Having a great extent such as in physical dimensions, period of time, amplitude or frequency.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Small</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012591</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Liminal</name>
                        <description>Situated at a sensory threshold that is barely perceptible or capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Subliminal</value>
                           <value>Supraliminal</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012592</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Loud</name>
                        <description>Having a perceived high intensity of sound.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Quiet</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012593</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Low</name>
                        <description>Less than normal in degree, intensity or amount.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>High</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012594</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Medium</name>
                        <description>Mid-way between small and large in number, quantity, magnitude or extent.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Low</value>
                           <value>High</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012595</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Negative</name>
                        <description>Involving disadvantage or harm.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Positive</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012596</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Positive</name>
                        <description>Involving advantage or good.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Negative</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012597</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Quiet</name>
                        <description>Characterizing a perceived low intensity of sound.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Loud</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012598</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rough</name>
                        <description>Having a surface with perceptible bumps, ridges, or irregularities.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Smooth</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012599</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Shallow</name>
                        <description>Having a depth which is relatively low.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Deep</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012600</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Small</name>
                        <description>Having a small extent such as in physical dimensions, period of time, amplitude or frequency.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Large</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012601</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Smooth</name>
                        <description>Having a surface free from bumps, ridges, or irregularities.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Rough</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012602</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Subliminal</name>
                        <description>Situated below a sensory threshold that is imperceptible or not capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Liminal</value>
                           <value>Supraliminal</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012603</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Supraliminal</name>
                        <description>Situated above a sensory threshold that is perceptible or capable of eliciting a response.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Liminal</value>
                           <value>Subliminal</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012604</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Thick</name>
                        <description>Wide in width, extent or cross-section.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Thin</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012605</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Thin</name>
                        <description>Narrow in width, extent or cross-section.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Thick</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012606</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-location-value</name>
                     <description>Value indicating the location of something, primarily as an identifier rather than an expression of where the item is relative to something else.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012607</value>
                     </attribute>
                     <node>
                        <name>Anterior</name>
                        <description>Relating to an item on the front of an agent body (from the point of view of the agent) or on the front of an object from the point of view of an agent. This pertains to the identity of an agent or a thing.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012608</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Lateral</name>
                        <description>Identifying the portion of an object away from the midline, particularly applied to the (anterior-posterior, superior-inferior) surface of a brain.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012609</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Left</name>
                        <description>Relating to an item on the left side of an agent body (from the point of view of the agent) or the left side of an object from the point of view of an agent. This pertains to the identity of an agent or a thing, for example (Left, Hand) as an identifier for the left hand. HED spatial relations should be used for relative positions such as (Hand, (Left-side-of, Keyboard)), which denotes the hand placed on the left side of the keyboard, which could be either the identified left hand or right hand.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012610</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Medial</name>
                        <description>Identifying the portion of an object towards the center, particularly applied to the (anterior-posterior, superior-inferior) surface of a brain.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012611</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Posterior</name>
                        <description>Relating to an item on the back of an agent body (from the point of view of the agent) or on the back of an object from the point of view of an agent. This pertains to the identity of an agent or a thing.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012612</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Right</name>
                        <description>Relating to an item on the right side of an agent body (from the point of view of the agent) or the right side of an object from the point of view of an agent. This pertains to the identity of an agent or a thing, for example (Right, Hand) as an identifier for the right hand. HED spatial relations should be used for relative positions such as (Hand, (Right-side-of, Keyboard)), which denotes the hand placed on the right side of the keyboard, which could be either the identified left hand or right hand.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012613</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Categorical-orientation-value</name>
                     <description>Value indicating the orientation or direction of something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012614</value>
                     </attribute>
                     <node>
                        <name>Backward</name>
                        <description>Directed behind or to the rear.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Forward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012615</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Downward</name>
                        <description>Moving or leading toward a lower place or level.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Leftward</value>
                           <value>Rightward</value>
                           <value>Upward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012616</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Forward</name>
                        <description>At or near or directed toward the front.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Backward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012617</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Horizontally-oriented</name>
                        <description>Oriented parallel to or in the plane of the horizon.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Vertically-oriented</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012618</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Leftward</name>
                        <description>Going toward or facing the left.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Rightward</value>
                           <value>Upward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012619</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Oblique</name>
                        <description>Slanting or inclined in direction, course, or position that is neither parallel nor perpendicular nor right-angular.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Rotated</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012620</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rightward</name>
                        <description>Going toward or situated on the right.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Leftward</value>
                           <value>Upward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012621</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Rotated</name>
                        <description>Positioned offset around an axis or center.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012622</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Upward</name>
                        <description>Moving, pointing, or leading to a higher place, point, or level.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Downward</value>
                           <value>Leftward</value>
                           <value>Rightward</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012623</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Vertically-oriented</name>
                        <description>Oriented perpendicular to the plane of the horizon.</description>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Horizontally-oriented</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012624</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Physical-value</name>
                  <description>The value of some physical property of something.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012625</value>
                  </attribute>
                  <node>
                     <name>Temperature</name>
                     <description>A measure of hot or cold based on the average kinetic energy of the atoms or molecules in the system.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012626</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>temperatureUnits</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012627</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Weight</name>
                     <description>The relative mass or the quantity of matter contained by something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012628</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>weightUnits</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012629</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Quantitative-value</name>
                  <description>Something capable of being estimated or expressed with numeric values.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012630</value>
                  </attribute>
                  <node>
                     <name>Fraction</name>
                     <description>A numerical value between 0 and 1.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012631</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012632</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-count</name>
                     <description>The integer count of something which is usually grouped with the entity it is counting. (Item-count/3, A) indicates that 3 of A have occurred up to this point.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012633</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012634</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-index</name>
                     <description>The index of an item in a collection, sequence or other structure. (A (Item-index/3, B)) means that A is item number 3 in B.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012635</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012636</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Item-interval</name>
                     <description>An integer indicating how many items or entities have passed since the last one of these. An item interval of 0 indicates the current item.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012637</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012638</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Percentage</name>
                     <description>A fraction or ratio with 100 understood as the denominator.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012639</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012640</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Ratio</name>
                     <description>A quotient of quantities of the same kind for different components within the same system.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012641</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012642</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Spatiotemporal-value</name>
                  <description>A property relating to space and/or time.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012643</value>
                  </attribute>
                  <node>
                     <name>Rate-of-change</name>
                     <description>The amount of change accumulated per unit time.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012644</value>
                     </attribute>
                     <node>
                        <name>Acceleration</name>
                        <description>Magnitude of the rate of change in either speed or direction. The direction of change should be given separately.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012645</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>accelerationUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012646</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Frequency</name>
                        <description>Frequency is the number of occurrences of a repeating event per unit time.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012647</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012648</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Jerk-rate</name>
                        <description>Magnitude of the rate at which the acceleration of an object changes with respect to time. The direction of change should be given separately.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012649</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>jerkUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012650</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Refresh-rate</name>
                        <description>The frequency with which the image on a computer monitor or similar electronic display screen is refreshed, usually expressed in hertz.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012651</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012652</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sampling-rate</name>
                        <description>The number of digital samples taken or recorded per unit of time.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012653</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012654</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Speed</name>
                        <description>A scalar measure of the rate of movement of the object expressed either as the distance traveled divided by the time taken (average speed) or the rate of change of position with respect to time at a particular point (instantaneous speed). The direction of change should be given separately.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012655</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>speedUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012656</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Temporal-rate</name>
                        <description>The number of items per unit of time.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012657</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>frequencyUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012658</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Spatial-value</name>
                     <description>Value of an item involving space.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012659</value>
                     </attribute>
                     <node>
                        <name>Angle</name>
                        <description>The amount of inclination of one line to another or the plane of one object to another.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012660</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>angleUnits</value>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012661</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Distance</name>
                        <description>A measure of the space separating two objects or points.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012662</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>physicalLengthUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012663</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Position</name>
                        <description>A reference to the alignment of an object, a particular situation or view of a situation, or the location of an object. Coordinates with respect a specified frame of reference or the default Screen-frame if no frame is given.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012664</value>
                        </attribute>
                        <node>
                           <name>Clock-face</name>
                           <description>A location identifier based on clock-face numbering or anatomic subregion. Replaced by Clock-face-position.</description>
                           <attribute>
                              <name>deprecatedFrom</name>
                              <value>8.2.0</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012326</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>deprecatedFrom</name>
                                 <value>8.2.0</value>
                              </attribute>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013228</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Clock-face-position</name>
                           <description>A location identifier based on clock-face numbering or anatomic subregion. As an object, just use the tag Clock.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013229</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013230</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>X-position</name>
                           <description>The position along the x-axis of the frame of reference.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012665</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012666</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Y-position</name>
                           <description>The position along the y-axis of the frame of reference.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012667</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012668</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Z-position</name>
                           <description>The position along the z-axis of the frame of reference.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012669</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012670</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Size</name>
                        <description>The physical magnitude of something.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012671</value>
                        </attribute>
                        <node>
                           <name>Area</name>
                           <description>The extent of a 2-dimensional surface enclosed within a boundary.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012672</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>areaUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012673</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Depth</name>
                           <description>The distance from the surface of something especially from the perspective of looking from the front.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012674</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012675</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Height</name>
                           <description>The vertical measurement or distance from the base to the top of an object.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012676</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012677</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Length</name>
                           <description>The linear extent in space from one end of something to the other end, or the extent of something from beginning to end.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012678</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012679</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Perimeter</name>
                           <description>The minimum length of paths enclosing a 2D shape.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012680</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012681</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Radius</name>
                           <description>The distance of the line from the center of a circle or a sphere to its perimeter or outer surface, respectively.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012682</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012683</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Volume</name>
                           <description>The amount of three dimensional space occupied by an object or the capacity of a space or container.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012684</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>volumeUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012685</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Width</name>
                           <description>The extent or measurement of something from side to side.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012686</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>unitClass</name>
                                 <value>physicalLengthUnits</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012687</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Temporal-value</name>
                     <description>A characteristic of or relating to time or limited by time.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012688</value>
                     </attribute>
                     <node>
                        <name>Delay</name>
                        <description>The time at which an event start time is delayed from the current onset time. This tag defines the start time of an event of temporal extent and may be used with the Duration tag.</description>
                        <attribute>
                           <name>topLevelTagGroup</name>
                        </attribute>
                        <attribute>
                           <name>reserved</name>
                        </attribute>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Duration</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012689</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012690</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Duration</name>
                        <description>The period of time during which an event occurs. This tag defines the end time of an event of temporal extent and may be used with the Delay tag.</description>
                        <attribute>
                           <name>topLevelTagGroup</name>
                        </attribute>
                        <attribute>
                           <name>reserved</name>
                        </attribute>
                        <attribute>
                           <name>requireChild</name>
                        </attribute>
                        <attribute>
                           <name>relatedTag</name>
                           <value>Delay</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012691</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012692</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Time-interval</name>
                        <description>The period of time separating two instances, events, or occurrences.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012693</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012694</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Time-value</name>
                        <description>A value with units of time. Usually grouped with tags identifying what the value represents.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012695</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012696</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Statistical-value</name>
                  <description>A value based on or employing the principles of statistics.</description>
                  <attribute>
                     <name>extensionAllowed</name>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012697</value>
                  </attribute>
                  <node>
                     <name>Data-maximum</name>
                     <description>The largest possible quantity or degree.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012698</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012699</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-mean</name>
                     <description>The sum of a set of values divided by the number of values in the set.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012700</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012701</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-median</name>
                     <description>The value which has an equal number of values greater and less than it.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012702</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012703</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Data-minimum</name>
                     <description>The smallest possible quantity.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012704</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012705</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Probability</name>
                     <description>A measure of the expectation of the occurrence of a particular event.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012706</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012707</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Standard-deviation</name>
                     <description>A measure of the range of values in a set of numbers. Standard deviation is a statistic used as a measure of the dispersion or variation in a distribution, equal to the square root of the arithmetic mean of the squares of the deviations from the arithmetic mean.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012708</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012709</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-accuracy</name>
                     <description>A measure of closeness to true value expressed as a number between 0 and 1.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012710</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012711</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-precision</name>
                     <description>A quantitative representation of the degree of accuracy necessary for or associated with a particular action.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012712</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012713</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-recall</name>
                     <description>Sensitivity is a measurement datum qualifying a binary classification test and is computed by subtracting the false negative rate to the integral numeral 1.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012714</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012715</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Statistical-uncertainty</name>
                     <description>A measure of the inherent variability of repeated observation measurements of a quantity including quantities evaluated by statistical methods and by other means.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012716</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012717</value>
                        </attribute>
                     </node>
                  </node>
               </node>
            </node>
            <node>
               <name>Data-variability-attribute</name>
               <description>An attribute describing how something changes or varies.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012718</value>
               </attribute>
               <node>
                  <name>Abrupt</name>
                  <description>Marked by sudden change.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012719</value>
                  </attribute>
               </node>
               <node>
                  <name>Constant</name>
                  <description>Continually recurring or continuing without interruption. Not changing in time or space.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012720</value>
                  </attribute>
               </node>
               <node>
                  <name>Continuous</name>
                  <description>Uninterrupted in time, sequence, substance, or extent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Discrete</value>
                     <value>Discontinuous</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012721</value>
                  </attribute>
               </node>
               <node>
                  <name>Decreasing</name>
                  <description>Becoming smaller or fewer in size, amount, intensity, or degree.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Increasing</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012722</value>
                  </attribute>
               </node>
               <node>
                  <name>Deterministic</name>
                  <description>No randomness is involved in the development of the future states of the element.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Random</value>
                     <value>Stochastic</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012723</value>
                  </attribute>
               </node>
               <node>
                  <name>Discontinuous</name>
                  <description>Having a gap in time, sequence, substance, or extent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Continuous</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012724</value>
                  </attribute>
               </node>
               <node>
                  <name>Discrete</name>
                  <description>Constituting a separate entities or parts.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Continuous</value>
                     <value>Discontinuous</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012725</value>
                  </attribute>
               </node>
               <node>
                  <name>Estimated-value</name>
                  <description>Something that has been calculated or measured approximately.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012726</value>
                  </attribute>
               </node>
               <node>
                  <name>Exact-value</name>
                  <description>A value that is viewed to the true value according to some standard.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012727</value>
                  </attribute>
               </node>
               <node>
                  <name>Flickering</name>
                  <description>Moving irregularly or unsteadily or burning or shining fitfully or with a fluctuating light.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012728</value>
                  </attribute>
               </node>
               <node>
                  <name>Fractal</name>
                  <description>Having extremely irregular curves or shapes for which any suitably chosen part is similar in shape to a given larger or smaller part when magnified or reduced to the same size.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012729</value>
                  </attribute>
               </node>
               <node>
                  <name>Increasing</name>
                  <description>Becoming greater in size, amount, or degree.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Decreasing</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012730</value>
                  </attribute>
               </node>
               <node>
                  <name>Random</name>
                  <description>Governed by or depending on chance. Lacking any definite plan or order or purpose.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Deterministic</value>
                     <value>Stochastic</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012731</value>
                  </attribute>
               </node>
               <node>
                  <name>Repetitive</name>
                  <description>A recurring action that is often non-purposeful.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012732</value>
                  </attribute>
               </node>
               <node>
                  <name>Stochastic</name>
                  <description>Uses a random probability distribution or pattern that may be analyzed statistically but may not be predicted precisely to determine future states.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Deterministic</value>
                     <value>Random</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012733</value>
                  </attribute>
               </node>
               <node>
                  <name>Varying</name>
                  <description>Differing in size, amount, degree, or nature.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012734</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Environmental-property</name>
            <description>Relating to or arising from the surroundings of an agent.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012735</value>
            </attribute>
            <node>
               <name>Augmented-reality</name>
               <description>Using technology that enhances real-world experiences with computer-derived digital overlays to change some aspects of perception of the natural environment. The digital content is shown to the user through a smart device or glasses and responds to changes in the environment.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012736</value>
               </attribute>
            </node>
            <node>
               <name>Indoors</name>
               <description>Located inside a building or enclosure.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012737</value>
               </attribute>
            </node>
            <node>
               <name>Motion-platform</name>
               <description>A mechanism that creates the feelings of being in a real motion environment.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012738</value>
               </attribute>
            </node>
            <node>
               <name>Outdoors</name>
               <description>Any area outside a building or shelter.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012739</value>
               </attribute>
            </node>
            <node>
               <name>Real-world</name>
               <description>Located in a place that exists in real space and time under realistic conditions.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012740</value>
               </attribute>
            </node>
            <node>
               <name>Rural</name>
               <description>Of or pertaining to the country as opposed to the city.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012741</value>
               </attribute>
            </node>
            <node>
               <name>Terrain</name>
               <description>Characterization of the physical features of a tract of land.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012742</value>
               </attribute>
               <node>
                  <name>Composite-terrain</name>
                  <description>Tracts of land characterized by a mixture of physical features.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012743</value>
                  </attribute>
               </node>
               <node>
                  <name>Dirt-terrain</name>
                  <description>Tracts of land characterized by a soil surface and lack of vegetation.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012744</value>
                  </attribute>
               </node>
               <node>
                  <name>Grassy-terrain</name>
                  <description>Tracts of land covered by grass.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012745</value>
                  </attribute>
               </node>
               <node>
                  <name>Gravel-terrain</name>
                  <description>Tracts of land covered by a surface consisting a loose aggregation of small water-worn or pounded stones.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012746</value>
                  </attribute>
               </node>
               <node>
                  <name>Leaf-covered-terrain</name>
                  <description>Tracts of land covered by leaves and composited organic material.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012747</value>
                  </attribute>
               </node>
               <node>
                  <name>Muddy-terrain</name>
                  <description>Tracts of land covered by a liquid or semi-liquid mixture of water and some combination of soil, silt, and clay.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012748</value>
                  </attribute>
               </node>
               <node>
                  <name>Paved-terrain</name>
                  <description>Tracts of land covered with concrete, asphalt, stones, or bricks.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012749</value>
                  </attribute>
               </node>
               <node>
                  <name>Rocky-terrain</name>
                  <description>Tracts of land consisting or full of rock or rocks.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012750</value>
                  </attribute>
               </node>
               <node>
                  <name>Sloped-terrain</name>
                  <description>Tracts of land arranged in a sloping or inclined position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012751</value>
                  </attribute>
               </node>
               <node>
                  <name>Uneven-terrain</name>
                  <description>Tracts of land that are not level, smooth, or regular.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012752</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Urban</name>
               <description>Relating to, located in, or characteristic of a city or densely populated area.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012753</value>
               </attribute>
            </node>
            <node>
               <name>Virtual-world</name>
               <description>Using technology that creates immersive, computer-generated experiences that a person can interact with and navigate through. The digital content is generally delivered to the user through some type of headset and responds to changes in head position or through interaction with other types of sensors. Existing in a virtual setting such as a simulation or game environment.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012754</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Informational-property</name>
            <description>Something that pertains to a task.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0012755</value>
            </attribute>
            <node>
               <name>Description</name>
               <description>An explanation of what the tag group it is in means. If the description is at the top-level of an event string, the description applies to the event.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012756</value>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012757</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>ID</name>
               <description>An alphanumeric name that identifies either a unique object or a unique class of objects. Here the object or class may be an idea, physical countable object (or class), or physical uncountable substance (or class).</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012758</value>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>textClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012759</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Label</name>
               <description>A string of 20 or fewer characters identifying something. Labels usually refer to general classes of things while IDs refer to specific instances. A term that is associated with some entity. A brief description given for purposes of identification. An identifying or descriptive marker that is attached to an object.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012760</value>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012761</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Metadata</name>
               <description>Data about data. Information that describes another set of data.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012762</value>
               </attribute>
               <node>
                  <name>Creation-date</name>
                  <description>The date on which the creation of this item began.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012763</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>dateTimeClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012764</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Experimental-note</name>
                  <description>A brief written record about the experiment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012765</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012766</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Library-name</name>
                  <description>Official name of a HED library.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012767</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>nameClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012768</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Metadata-identifier</name>
                  <description>Identifier (usually unique) from another metadata source.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012769</value>
                  </attribute>
                  <node>
                     <name>CogAtlas</name>
                     <description>The Cognitive Atlas ID number of something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012770</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012771</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>CogPo</name>
                     <description>The CogPO ID number of something.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012772</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012773</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>DOI</name>
                     <description>Digital object identifier for an object.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012774</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012775</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>OBO-identifier</name>
                     <description>The identifier of a term in some Open Biology Ontology (OBO) ontology.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012776</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>nameClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012777</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Species-identifier</name>
                     <description>A binomial species name from the NCBI Taxonomy, for example, homo sapiens, mus musculus, or rattus norvegicus.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012778</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012779</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Subject-identifier</name>
                     <description>A sequence of characters used to identify, name, or characterize a trial or study subject.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012780</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012781</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>UUID</name>
                     <description>A unique universal identifier.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012782</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012783</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Version-identifier</name>
                     <description>An alphanumeric character string that identifies a form or variant of a type or original.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012784</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <description>Usually is a semantic version.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012785</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Modified-date</name>
                  <description>The date on which the item was modified (usually the last-modified data unless a complete record of dated modifications is kept.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012786</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>dateTimeClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012787</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Pathname</name>
                  <description>The specification of a node (file or directory) in a hierarchical file system, usually specified by listing the nodes top-down.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012788</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012789</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>URL</name>
                  <description>A valid URL.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012790</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012791</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Parameter</name>
               <description>Something user-defined for this experiment.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012792</value>
               </attribute>
               <node>
                  <name>Parameter-label</name>
                  <description>The name of the parameter.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012793</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>nameClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012794</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Parameter-value</name>
                  <description>The value of the parameter.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012795</value>
                  </attribute>
                  <node>
                     <name>#</name>
                     <attribute>
                        <name>takesValue</name>
                     </attribute>
                     <attribute>
                        <name>valueClass</name>
                        <value>textClass</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012796</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Organizational-property</name>
            <description>Relating to an organization or the action of organizing something.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012797</value>
            </attribute>
            <node>
               <name>Collection</name>
               <description>A tag designating a grouping of items such as in a set or list.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012798</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the collection.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012799</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Condition-variable</name>
               <description>An aspect of the experiment or task that is to be varied during the experiment. Task-conditions are sometimes called independent variables or contrasts.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012800</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the condition variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012801</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Control-variable</name>
               <description>An aspect of the experiment that is fixed throughout the study and usually is explicitly controlled.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012802</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the control variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012803</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Def</name>
               <description>A HED-specific utility tag used with a defined name to represent the tags associated with that definition.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012804</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the definition.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012805</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Def-expand</name>
               <description>A HED specific utility tag that is grouped with an expanded definition. The child value of the Def-expand is the name of the expanded definition.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>tagGroup</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012806</value>
               </attribute>
               <node>
                  <name>#</name>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012807</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Definition</name>
               <description>A HED-specific utility tag whose child value is the name of the concept and the tag group associated with the tag is an English language explanation of a concept.</description>
               <attribute>
                  <name>requireChild</name>
               </attribute>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>topLevelTagGroup</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012808</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the definition.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012809</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Event-context</name>
               <description>A special HED tag inserted as part of a top-level tag group to contain information about the interrelated conditions under which the event occurs. The event context includes information about other events that are ongoing when this event happens.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>topLevelTagGroup</name>
               </attribute>
               <attribute>
                  <name>unique</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012810</value>
               </attribute>
            </node>
            <node>
               <name>Event-stream</name>
               <description>A special HED tag indicating that this event is a member of an ordered succession of events.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012811</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the event stream.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012812</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Experimental-intertrial</name>
               <description>A tag used to indicate a part of the experiment between trials usually where nothing is happening.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012813</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Optional label for the intertrial block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012814</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Experimental-trial</name>
               <description>Designates a run or execution of an activity, for example, one execution of a script. A tag used to indicate a particular organizational part in the experimental design often containing a stimulus-response pair or stimulus-response-feedback triad.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012815</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Optional label for the trial (often a numerical string).</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012816</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Indicator-variable</name>
               <description>An aspect of the experiment or task that is measured as task conditions are varied during the experiment. Experiment indicators are sometimes called dependent variables.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012817</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Name of the indicator variable.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012818</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Recording</name>
               <description>A tag designating the data recording. Recording tags are usually have temporal scope which is the entire recording.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012819</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Optional label for the recording.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012820</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task</name>
               <description>An assigned piece of work, usually with a time allotment. A tag used to indicate a linkage the structured activities performed as part of the experiment.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012821</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Optional label for the task block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012822</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Time-block</name>
               <description>A tag used to indicate a contiguous time block in the experiment during which something is fixed or noted.</description>
               <attribute>
                  <name>reserved</name>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012823</value>
               </attribute>
               <node>
                  <name>#</name>
                  <description>Optional label for the task block.</description>
                  <attribute>
                     <name>takesValue</name>
                  </attribute>
                  <attribute>
                     <name>valueClass</name>
                     <value>nameClass</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012824</value>
                  </attribute>
               </node>
            </node>
         </node>
         <node>
            <name>Sensory-property</name>
            <description>Relating to sensation or the physical senses.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0012825</value>
            </attribute>
            <node>
               <name>Sensory-attribute</name>
               <description>A sensory characteristic associated with another entity.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0012826</value>
               </attribute>
               <node>
                  <name>Auditory-attribute</name>
                  <description>Pertaining to the sense of hearing.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012827</value>
                  </attribute>
                  <node>
                     <name>Loudness</name>
                     <description>Perceived intensity of a sound.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012828</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                           <value>nameClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012829</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Pitch</name>
                     <description>A perceptual property that allows the user to order sounds on a frequency scale.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012830</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>frequencyUnits</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012831</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Sound-envelope</name>
                     <description>Description of how a sound changes over time.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012832</value>
                     </attribute>
                     <node>
                        <name>Sound-envelope-attack</name>
                        <description>The time taken for initial run-up of level from nil to peak usually beginning when the key on a musical instrument is pressed.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012833</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012834</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-decay</name>
                        <description>The time taken for the subsequent run down from the attack level to the designated sustain level.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012835</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012836</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-release</name>
                        <description>The time taken for the level to decay from the sustain level to zero after the key is released.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012837</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012838</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Sound-envelope-sustain</name>
                        <description>The time taken for the main sequence of the sound duration, until the key is released.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012839</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>unitClass</name>
                              <value>timeUnits</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012840</value>
                           </attribute>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Sound-volume</name>
                     <description>The sound pressure level (SPL) usually the ratio to a reference signal estimated as the lower bound of hearing.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012841</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>unitClass</name>
                           <value>intensityUnits</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012842</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Timbre</name>
                     <description>The perceived sound quality of a singing voice or musical instrument.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012843</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>nameClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012844</value>
                        </attribute>
                     </node>
                  </node>
               </node>
               <node>
                  <name>Gustatory-attribute</name>
                  <description>Pertaining to the sense of taste.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012845</value>
                  </attribute>
                  <node>
                     <name>Bitter</name>
                     <description>Having a sharp, pungent taste.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012846</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Salty</name>
                     <description>Tasting of or like salt.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012847</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Savory</name>
                     <description>Belonging to a taste that is salty or spicy rather than sweet.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012848</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sour</name>
                     <description>Having a sharp, acidic taste.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012849</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Sweet</name>
                     <description>Having or resembling the taste of sugar.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012850</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Olfactory-attribute</name>
                  <description>Having a smell.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012851</value>
                  </attribute>
               </node>
               <node>
                  <name>Somatic-attribute</name>
                  <description>Pertaining to the feelings in the body or of the nervous system.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012852</value>
                  </attribute>
                  <node>
                     <name>Pain</name>
                     <description>The sensation of discomfort, distress, or agony, resulting from the stimulation of specialized nerve endings.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012853</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Stress</name>
                     <description>The negative mental, emotional, and physical reactions that occur when environmental stressors are perceived as exceeding the adaptive capacities of the individual.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012854</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Tactile-attribute</name>
                  <description>Pertaining to the sense of touch.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012855</value>
                  </attribute>
                  <node>
                     <name>Tactile-pressure</name>
                     <description>Having a feeling of heaviness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012856</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tactile-temperature</name>
                     <description>Having a feeling of hotness or coldness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012857</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tactile-texture</name>
                     <description>Having a feeling of roughness.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012858</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Tactile-vibration</name>
                     <description>Having a feeling of mechanical oscillation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012859</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Vestibular-attribute</name>
                  <description>Pertaining to the sense of balance or body position.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012860</value>
                  </attribute>
               </node>
               <node>
                  <name>Visual-attribute</name>
                  <description>Pertaining to the sense of sight.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0012861</value>
                  </attribute>
                  <node>
                     <name>Color</name>
                     <description>The appearance of objects (or light sources) described in terms of perception of their hue and lightness (or brightness) and saturation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0012862</value>
                     </attribute>
                     <node>
                        <name>CSS-color</name>
                        <description>One of 140 colors supported by all browsers. For more details such as the color RGB or HEX values,check:https://www.w3schools.com/colors/colors_groups.asp.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0012863</value>
                        </attribute>
                        <node>
                           <name>Blue-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012864</value>
                           </attribute>
                           <node>
                              <name>Blue</name>
                              <description>CSS-color 0x0000FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012865</value>
                              </attribute>
                           </node>
                           <node>
                              <name>CadetBlue</name>
                              <description>CSS-color 0x5F9EA0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012866</value>
                              </attribute>
                           </node>
                           <node>
                              <name>CornflowerBlue</name>
                              <description>CSS-color 0x6495ED.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012867</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkBlue</name>
                              <description>CSS-color 0x00008B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012868</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DeepSkyBlue</name>
                              <description>CSS-color 0x00BFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012869</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DodgerBlue</name>
                              <description>CSS-color 0x1E90FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012870</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightBlue</name>
                              <description>CSS-color 0xADD8E6.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012871</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightSkyBlue</name>
                              <description>CSS-color 0x87CEFA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012872</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightSteelBlue</name>
                              <description>CSS-color 0xB0C4DE.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012873</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumBlue</name>
                              <description>CSS-color 0x0000CD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012874</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MidnightBlue</name>
                              <description>CSS-color 0x191970.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012875</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Navy</name>
                              <description>CSS-color 0x000080.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012876</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PowderBlue</name>
                              <description>CSS-color 0xB0E0E6.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012877</value>
                              </attribute>
                           </node>
                           <node>
                              <name>RoyalBlue</name>
                              <description>CSS-color 0x4169E1.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012878</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SkyBlue</name>
                              <description>CSS-color 0x87CEEB.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012879</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SteelBlue</name>
                              <description>CSS-color 0x4682B4.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012880</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Brown-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012881</value>
                           </attribute>
                           <node>
                              <name>Bisque</name>
                              <description>CSS-color 0xFFE4C4.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012882</value>
                              </attribute>
                           </node>
                           <node>
                              <name>BlanchedAlmond</name>
                              <description>CSS-color 0xFFEBCD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012883</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Brown</name>
                              <description>CSS-color 0xA52A2A.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012884</value>
                              </attribute>
                           </node>
                           <node>
                              <name>BurlyWood</name>
                              <description>CSS-color 0xDEB887.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012885</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Chocolate</name>
                              <description>CSS-color 0xD2691E.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012886</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Cornsilk</name>
                              <description>CSS-color 0xFFF8DC.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012887</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkGoldenRod</name>
                              <description>CSS-color 0xB8860B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012888</value>
                              </attribute>
                           </node>
                           <node>
                              <name>GoldenRod</name>
                              <description>CSS-color 0xDAA520.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012889</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Maroon</name>
                              <description>CSS-color 0x800000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012890</value>
                              </attribute>
                           </node>
                           <node>
                              <name>NavajoWhite</name>
                              <description>CSS-color 0xFFDEAD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012891</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Olive</name>
                              <description>CSS-color 0x808000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012892</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Peru</name>
                              <description>CSS-color 0xCD853F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012893</value>
                              </attribute>
                           </node>
                           <node>
                              <name>RosyBrown</name>
                              <description>CSS-color 0xBC8F8F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012894</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SaddleBrown</name>
                              <description>CSS-color 0x8B4513.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012895</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SandyBrown</name>
                              <description>CSS-color 0xF4A460.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012896</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Sienna</name>
                              <description>CSS-color 0xA0522D.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012897</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Tan</name>
                              <description>CSS-color 0xD2B48C.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012898</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Wheat</name>
                              <description>CSS-color 0xF5DEB3.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012899</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Cyan-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012900</value>
                           </attribute>
                           <node>
                              <name>Aqua</name>
                              <description>CSS-color 0x00FFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012901</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Aquamarine</name>
                              <description>CSS-color 0x7FFFD4.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012902</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Cyan</name>
                              <description>CSS-color 0x00FFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012903</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkTurquoise</name>
                              <description>CSS-color 0x00CED1.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012904</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightCyan</name>
                              <description>CSS-color 0xE0FFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012905</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumTurquoise</name>
                              <description>CSS-color 0x48D1CC.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012906</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PaleTurquoise</name>
                              <description>CSS-color 0xAFEEEE.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012907</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Turquoise</name>
                              <description>CSS-color 0x40E0D0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012908</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Gray-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012909</value>
                           </attribute>
                           <node>
                              <name>Black</name>
                              <description>CSS-color 0x000000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012910</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkGray</name>
                              <description>CSS-color 0xA9A9A9.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012911</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkSlateGray</name>
                              <description>CSS-color 0x2F4F4F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012912</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DimGray</name>
                              <description>CSS-color 0x696969.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012913</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Gainsboro</name>
                              <description>CSS-color 0xDCDCDC.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012914</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Gray</name>
                              <description>CSS-color 0x808080.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012915</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightGray</name>
                              <description>CSS-color 0xD3D3D3.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012916</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightSlateGray</name>
                              <description>CSS-color 0x778899.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012917</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Silver</name>
                              <description>CSS-color 0xC0C0C0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012918</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SlateGray</name>
                              <description>CSS-color 0x708090.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012919</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Green-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012920</value>
                           </attribute>
                           <node>
                              <name>Chartreuse</name>
                              <description>CSS-color 0x7FFF00.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012921</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkCyan</name>
                              <description>CSS-color 0x008B8B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012922</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkGreen</name>
                              <description>CSS-color 0x006400.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012923</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkOliveGreen</name>
                              <description>CSS-color 0x556B2F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012924</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkSeaGreen</name>
                              <description>CSS-color 0x8FBC8F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012925</value>
                              </attribute>
                           </node>
                           <node>
                              <name>ForestGreen</name>
                              <description>CSS-color 0x228B22.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012926</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Green</name>
                              <description>CSS-color 0x008000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012927</value>
                              </attribute>
                           </node>
                           <node>
                              <name>GreenYellow</name>
                              <description>CSS-color 0xADFF2F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012928</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LawnGreen</name>
                              <description>CSS-color 0x7CFC00.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012929</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightGreen</name>
                              <description>CSS-color 0x90EE90.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012930</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightSeaGreen</name>
                              <description>CSS-color 0x20B2AA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012931</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Lime</name>
                              <description>CSS-color 0x00FF00.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012932</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LimeGreen</name>
                              <description>CSS-color 0x32CD32.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012933</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumAquaMarine</name>
                              <description>CSS-color 0x66CDAA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012934</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumSeaGreen</name>
                              <description>CSS-color 0x3CB371.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012935</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumSpringGreen</name>
                              <description>CSS-color 0x00FA9A.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012936</value>
                              </attribute>
                           </node>
                           <node>
                              <name>OliveDrab</name>
                              <description>CSS-color 0x6B8E23.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012937</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PaleGreen</name>
                              <description>CSS-color 0x98FB98.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012938</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SeaGreen</name>
                              <description>CSS-color 0x2E8B57.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012939</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SpringGreen</name>
                              <description>CSS-color 0x00FF7F.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012940</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Teal</name>
                              <description>CSS-color 0x008080.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012941</value>
                              </attribute>
                           </node>
                           <node>
                              <name>YellowGreen</name>
                              <description>CSS-color 0x9ACD32.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012942</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Orange-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012943</value>
                           </attribute>
                           <node>
                              <name>Coral</name>
                              <description>CSS-color 0xFF7F50.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012944</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkOrange</name>
                              <description>CSS-color 0xFF8C00.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012945</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Orange</name>
                              <description>CSS-color 0xFFA500.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012946</value>
                              </attribute>
                           </node>
                           <node>
                              <name>OrangeRed</name>
                              <description>CSS-color 0xFF4500.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012947</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Tomato</name>
                              <description>CSS-color 0xFF6347.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012948</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Pink-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012949</value>
                           </attribute>
                           <node>
                              <name>DeepPink</name>
                              <description>CSS-color 0xFF1493.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012950</value>
                              </attribute>
                           </node>
                           <node>
                              <name>HotPink</name>
                              <description>CSS-color 0xFF69B4.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012951</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightPink</name>
                              <description>CSS-color 0xFFB6C1.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012952</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumVioletRed</name>
                              <description>CSS-color 0xC71585.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012953</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PaleVioletRed</name>
                              <description>CSS-color 0xDB7093.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012954</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Pink</name>
                              <description>CSS-color 0xFFC0CB.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012955</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Purple-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012956</value>
                           </attribute>
                           <node>
                              <name>BlueViolet</name>
                              <description>CSS-color 0x8A2BE2.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012957</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkMagenta</name>
                              <description>CSS-color 0x8B008B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012958</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkOrchid</name>
                              <description>CSS-color 0x9932CC.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012959</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkSlateBlue</name>
                              <description>CSS-color 0x483D8B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012960</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkViolet</name>
                              <description>CSS-color 0x9400D3.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012961</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Fuchsia</name>
                              <description>CSS-color 0xFF00FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012962</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Indigo</name>
                              <description>CSS-color 0x4B0082.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012963</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Lavender</name>
                              <description>CSS-color 0xE6E6FA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012964</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Magenta</name>
                              <description>CSS-color 0xFF00FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012965</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumOrchid</name>
                              <description>CSS-color 0xBA55D3.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012966</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumPurple</name>
                              <description>CSS-color 0x9370DB.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012967</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MediumSlateBlue</name>
                              <description>CSS-color 0x7B68EE.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012968</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Orchid</name>
                              <description>CSS-color 0xDA70D6.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012969</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Plum</name>
                              <description>CSS-color 0xDDA0DD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012970</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Purple</name>
                              <description>CSS-color 0x800080.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012971</value>
                              </attribute>
                           </node>
                           <node>
                              <name>RebeccaPurple</name>
                              <description>CSS-color 0x663399.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012972</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SlateBlue</name>
                              <description>CSS-color 0x6A5ACD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012973</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Thistle</name>
                              <description>CSS-color 0xD8BFD8.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012974</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Violet</name>
                              <description>CSS-color 0xEE82EE.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012975</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Red-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012976</value>
                           </attribute>
                           <node>
                              <name>Crimson</name>
                              <description>CSS-color 0xDC143C.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012977</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkRed</name>
                              <description>CSS-color 0x8B0000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012978</value>
                              </attribute>
                           </node>
                           <node>
                              <name>DarkSalmon</name>
                              <description>CSS-color 0xE9967A.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012979</value>
                              </attribute>
                           </node>
                           <node>
                              <name>FireBrick</name>
                              <description>CSS-color 0xB22222.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012980</value>
                              </attribute>
                           </node>
                           <node>
                              <name>IndianRed</name>
                              <description>CSS-color 0xCD5C5C.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012981</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightCoral</name>
                              <description>CSS-color 0xF08080.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012982</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightSalmon</name>
                              <description>CSS-color 0xFFA07A.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012983</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Red</name>
                              <description>CSS-color 0xFF0000.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012984</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Salmon</name>
                              <description>CSS-color 0xFA8072.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012985</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>White-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0012986</value>
                           </attribute>
                           <node>
                              <name>AliceBlue</name>
                              <description>CSS-color 0xF0F8FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012987</value>
                              </attribute>
                           </node>
                           <node>
                              <name>AntiqueWhite</name>
                              <description>CSS-color 0xFAEBD7.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012988</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Azure</name>
                              <description>CSS-color 0xF0FFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012989</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Beige</name>
                              <description>CSS-color 0xF5F5DC.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012990</value>
                              </attribute>
                           </node>
                           <node>
                              <name>FloralWhite</name>
                              <description>CSS-color 0xFFFAF0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012991</value>
                              </attribute>
                           </node>
                           <node>
                              <name>GhostWhite</name>
                              <description>CSS-color 0xF8F8FF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012992</value>
                              </attribute>
                           </node>
                           <node>
                              <name>HoneyDew</name>
                              <description>CSS-color 0xF0FFF0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012993</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Ivory</name>
                              <description>CSS-color 0xFFFFF0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012994</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LavenderBlush</name>
                              <description>CSS-color 0xFFF0F5.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012995</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Linen</name>
                              <description>CSS-color 0xFAF0E6.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012996</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MintCream</name>
                              <description>CSS-color 0xF5FFFA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012997</value>
                              </attribute>
                           </node>
                           <node>
                              <name>MistyRose</name>
                              <description>CSS-color 0xFFE4E1.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012998</value>
                              </attribute>
                           </node>
                           <node>
                              <name>OldLace</name>
                              <description>CSS-color 0xFDF5E6.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0012999</value>
                              </attribute>
                           </node>
                           <node>
                              <name>SeaShell</name>
                              <description>CSS-color 0xFFF5EE.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013000</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Snow</name>
                              <description>CSS-color 0xFFFAFA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013001</value>
                              </attribute>
                           </node>
                           <node>
                              <name>White</name>
                              <description>CSS-color 0xFFFFFF.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013002</value>
                              </attribute>
                           </node>
                           <node>
                              <name>WhiteSmoke</name>
                              <description>CSS-color 0xF5F5F5.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013003</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Yellow-color</name>
                           <description>CSS color group.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013004</value>
                           </attribute>
                           <node>
                              <name>DarkKhaki</name>
                              <description>CSS-color 0xBDB76B.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013005</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Gold</name>
                              <description>CSS-color 0xFFD700.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013006</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Khaki</name>
                              <description>CSS-color 0xF0E68C.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013007</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LemonChiffon</name>
                              <description>CSS-color 0xFFFACD.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013008</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightGoldenRodYellow</name>
                              <description>CSS-color 0xFAFAD2.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013009</value>
                              </attribute>
                           </node>
                           <node>
                              <name>LightYellow</name>
                              <description>CSS-color 0xFFFFE0.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013010</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Moccasin</name>
                              <description>CSS-color 0xFFE4B5.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013011</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PaleGoldenRod</name>
                              <description>CSS-color 0xEEE8AA.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013012</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PapayaWhip</name>
                              <description>CSS-color 0xFFEFD5.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013013</value>
                              </attribute>
                           </node>
                           <node>
                              <name>PeachPuff</name>
                              <description>CSS-color 0xFFDAB9.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013014</value>
                              </attribute>
                           </node>
                           <node>
                              <name>Yellow</name>
                              <description>CSS-color 0xFFFF00.</description>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013015</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>Color-shade</name>
                        <description>A slight degree of difference between colors, especially with regard to how light or dark it is or as distinguished from one nearly like it.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013016</value>
                        </attribute>
                        <node>
                           <name>Dark-shade</name>
                           <description>A color tone not reflecting much light.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013017</value>
                           </attribute>
                        </node>
                        <node>
                           <name>Light-shade</name>
                           <description>A color tone reflecting more light.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013018</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>Grayscale</name>
                        <description>Using a color map composed of shades of gray, varying from black at the weakest intensity to white at the strongest.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013019</value>
                        </attribute>
                        <node>
                           <name>#</name>
                           <description>White intensity between 0 and 1.</description>
                           <attribute>
                              <name>takesValue</name>
                           </attribute>
                           <attribute>
                              <name>valueClass</name>
                              <value>numericClass</value>
                           </attribute>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013020</value>
                           </attribute>
                        </node>
                     </node>
                     <node>
                        <name>HSV-color</name>
                        <description>A color representation that models how colors appear under light.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013021</value>
                        </attribute>
                        <node>
                           <name>HSV-value</name>
                           <description>An attribute of a visual sensation according to which an area appears to emit more or less light.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013022</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013023</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Hue</name>
                           <description>Attribute of a visual sensation according to which an area appears to be similar to one of the perceived colors.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013024</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <description>Angular value between 0 and 360.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013025</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>Saturation</name>
                           <description>Colorfulness of a stimulus relative to its own brightness.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013026</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <description>B value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013027</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                     <node>
                        <name>RGB-color</name>
                        <description>A color from the RGB schema.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013028</value>
                        </attribute>
                        <node>
                           <name>RGB-blue</name>
                           <description>The blue component.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013029</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <description>B value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013030</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>RGB-green</name>
                           <description>The green component.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013031</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <description>G value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013032</value>
                              </attribute>
                           </node>
                        </node>
                        <node>
                           <name>RGB-red</name>
                           <description>The red component.</description>
                           <attribute>
                              <name>hedId</name>
                              <value>HED_0013033</value>
                           </attribute>
                           <node>
                              <name>#</name>
                              <description>R value of RGB between 0 and 1.</description>
                              <attribute>
                                 <name>takesValue</name>
                              </attribute>
                              <attribute>
                                 <name>valueClass</name>
                                 <value>numericClass</value>
                              </attribute>
                              <attribute>
                                 <name>hedId</name>
                                 <value>HED_0013034</value>
                              </attribute>
                           </node>
                        </node>
                     </node>
                  </node>
                  <node>
                     <name>Luminance</name>
                     <description>A quality that exists by virtue of the luminous intensity per unit area projected in a given direction.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013035</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Luminance-contrast</name>
                     <description>The difference in luminance in specific portions of a scene or image.</description>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Percentage</value>
                        <value>Ratio</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013036</value>
                     </attribute>
                     <node>
                        <name>#</name>
                        <description>A non-negative value, usually in the range 0 to 1 or alternative 0 to 100, if representing a percentage.</description>
                        <attribute>
                           <name>takesValue</name>
                        </attribute>
                        <attribute>
                           <name>valueClass</name>
                           <value>numericClass</value>
                        </attribute>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013037</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Opacity</name>
                     <description>A measure of impenetrability to light.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013038</value>
                     </attribute>
                  </node>
               </node>
            </node>
            <node>
               <name>Sensory-presentation</name>
               <description>The entity has a sensory manifestation.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013039</value>
               </attribute>
               <node>
                  <name>Auditory-presentation</name>
                  <description>The sense of hearing is used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013040</value>
                  </attribute>
                  <node>
                     <name>Loudspeaker-separation</name>
                     <description>The distance between two loudspeakers. Grouped with the Distance tag.</description>
                     <attribute>
                        <name>suggestedTag</name>
                        <value>Distance</value>
                     </attribute>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013041</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Monophonic</name>
                     <description>Relating to sound transmission, recording, or reproduction involving a single transmission path.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013042</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Silent</name>
                     <description>The absence of ambient audible sound or the state of having ceased to produce sounds.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013043</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Stereophonic</name>
                     <description>Relating to, or constituting sound reproduction involving the use of separated microphones and two transmission channels to achieve the sound separation of a live hearing.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013044</value>
                     </attribute>
                  </node>
               </node>
               <node>
                  <name>Gustatory-presentation</name>
                  <description>The sense of taste used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013045</value>
                  </attribute>
               </node>
               <node>
                  <name>Olfactory-presentation</name>
                  <description>The sense of smell used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013046</value>
                  </attribute>
               </node>
               <node>
                  <name>Somatic-presentation</name>
                  <description>The nervous system is used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013047</value>
                  </attribute>
               </node>
               <node>
                  <name>Tactile-presentation</name>
                  <description>The sense of touch used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013048</value>
                  </attribute>
               </node>
               <node>
                  <name>Vestibular-presentation</name>
                  <description>The sense balance used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013049</value>
                  </attribute>
               </node>
               <node>
                  <name>Visual-presentation</name>
                  <description>The sense of sight used in the presentation to the user.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013050</value>
                  </attribute>
                  <node>
                     <name>2D-view</name>
                     <description>A view showing only two dimensions.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013051</value>
                     </attribute>
                  </node>
                  <node>
                     <name>3D-view</name>
                     <description>A view showing three dimensions.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013052</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Background-view</name>
                     <description>Parts of the view that are farthest from the viewer and usually the not part of the visual focus.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013053</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Bistable-view</name>
                     <description>Something having two stable visual forms that have two distinguishable stable forms as in optical illusions.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013054</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Foreground-view</name>
                     <description>Parts of the view that are closest to the viewer and usually the most important part of the visual focus.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013055</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Foveal-view</name>
                     <description>Visual presentation directly on the fovea. A view projected on the small depression in the retina containing only cones and where vision is most acute.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013056</value>
                     </attribute>
                  </node>
                  <node>
                     <name>Map-view</name>
                     <description>A diagrammatic representation of an area of land or sea showing physical features, cities, roads.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013057</value>
                     </attribute>
                     <node>
                        <name>Aerial-view</name>
                        <description>Elevated view of an object from above, with a perspective as though the observer were a bird.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013058</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Satellite-view</name>
                        <description>A representation as captured by technology such as a satellite.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013059</value>
                        </attribute>
                     </node>
                     <node>
                        <name>Street-view</name>
                        <description>A 360-degrees panoramic view from a position on the ground.</description>
                        <attribute>
                           <name>hedId</name>
                           <value>HED_0013060</value>
                        </attribute>
                     </node>
                  </node>
                  <node>
                     <name>Peripheral-view</name>
                     <description>Indirect vision as it occurs outside the point of fixation.</description>
                     <attribute>
                        <name>hedId</name>
                        <value>HED_0013061</value>
                     </attribute>
                  </node>
               </node>
            </node>
         </node>
         <node>
            <name>Task-property</name>
            <description>Something that pertains to a task.</description>
            <attribute>
               <name>extensionAllowed</name>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0013062</value>
            </attribute>
            <node>
               <name>Task-action-type</name>
               <description>How an agent action should be interpreted in terms of the task specification.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013063</value>
               </attribute>
               <node>
                  <name>Appropriate-action</name>
                  <description>An action suitable or proper in the circumstances.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Inappropriate-action</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013064</value>
                  </attribute>
               </node>
               <node>
                  <name>Correct-action</name>
                  <description>An action that was a correct response in the context of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Incorrect-action</value>
                     <value>Indeterminate-action</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013065</value>
                  </attribute>
               </node>
               <node>
                  <name>Correction</name>
                  <description>An action offering an improvement to replace a mistake or error.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013066</value>
                  </attribute>
               </node>
               <node>
                  <name>Done-indication</name>
                  <description>An action that indicates that the participant has completed this step in the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Ready-indication</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013067</value>
                  </attribute>
               </node>
               <node>
                  <name>Imagined-action</name>
                  <description>Form a mental image or concept of something. This is used to identity something that only happened in the imagination of the participant as in imagined movements in motor imagery paradigms.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013068</value>
                  </attribute>
               </node>
               <node>
                  <name>Inappropriate-action</name>
                  <description>An action not in keeping with what is correct or proper for the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Appropriate-action</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013069</value>
                  </attribute>
               </node>
               <node>
                  <name>Incorrect-action</name>
                  <description>An action considered wrong or incorrect in the context of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Correct-action</value>
                     <value>Indeterminate-action</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013070</value>
                  </attribute>
               </node>
               <node>
                  <name>Indeterminate-action</name>
                  <description>An action that cannot be distinguished between two or more possibilities in the current context. This tag might be applied when an outside evaluator or a classification algorithm cannot determine a definitive result.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Correct-action</value>
                     <value>Incorrect-action</value>
                     <value>Miss</value>
                     <value>Near-miss</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013071</value>
                  </attribute>
               </node>
               <node>
                  <name>Miss</name>
                  <description>An action considered to be a failure in the context of the task. For example, if the agent is supposed to try to hit a target and misses.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Near-miss</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013072</value>
                  </attribute>
               </node>
               <node>
                  <name>Near-miss</name>
                  <description>An action barely satisfied the requirements of the task. In a driving experiment for example this could pertain to a narrowly avoided collision or other accident.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Miss</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013073</value>
                  </attribute>
               </node>
               <node>
                  <name>Omitted-action</name>
                  <description>An expected response was skipped.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013074</value>
                  </attribute>
               </node>
               <node>
                  <name>Ready-indication</name>
                  <description>An action that indicates that the participant is ready to perform the next step in the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Done-indication</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013075</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-attentional-demand</name>
               <description>Strategy for allocating attention toward goal-relevant information.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013076</value>
               </attribute>
               <node>
                  <name>Bottom-up-attention</name>
                  <description>Attentional guidance purely by externally driven factors to stimuli that are salient because of their inherent properties relative to the background. Sometimes this is referred to as stimulus driven.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Top-down-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013077</value>
                  </attribute>
               </node>
               <node>
                  <name>Covert-attention</name>
                  <description>Paying attention without moving the eyes.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Overt-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013078</value>
                  </attribute>
               </node>
               <node>
                  <name>Divided-attention</name>
                  <description>Integrating parallel multiple stimuli. Behavior involving responding simultaneously to multiple tasks or multiple task demands.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Focused-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013079</value>
                  </attribute>
               </node>
               <node>
                  <name>Focused-attention</name>
                  <description>Responding discretely to specific visual, auditory, or tactile stimuli.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Divided-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013080</value>
                  </attribute>
               </node>
               <node>
                  <name>Orienting-attention</name>
                  <description>Directing attention to a target stimulus.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013081</value>
                  </attribute>
               </node>
               <node>
                  <name>Overt-attention</name>
                  <description>Selectively processing one location over others by moving the eyes to point at that location.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Covert-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013082</value>
                  </attribute>
               </node>
               <node>
                  <name>Selective-attention</name>
                  <description>Maintaining a behavioral or cognitive set in the face of distracting or competing stimuli. Ability to pay attention to a limited array of all available sensory information.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013083</value>
                  </attribute>
               </node>
               <node>
                  <name>Sustained-attention</name>
                  <description>Maintaining a consistent behavioral response during continuous and repetitive activity.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013084</value>
                  </attribute>
               </node>
               <node>
                  <name>Switched-attention</name>
                  <description>Having to switch attention between two or more modalities of presentation.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013085</value>
                  </attribute>
               </node>
               <node>
                  <name>Top-down-attention</name>
                  <description>Voluntary allocation of attention to certain features. Sometimes this is referred to goal-oriented attention.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Bottom-up-attention</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013086</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-effect-evidence</name>
               <description>The evidence supporting the conclusion that the event had the specified effect.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013087</value>
               </attribute>
               <node>
                  <name>Behavioral-evidence</name>
                  <description>An indication or conclusion based on the behavior of an agent.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013088</value>
                  </attribute>
               </node>
               <node>
                  <name>Computational-evidence</name>
                  <description>A type of evidence in which data are produced, and/or generated, and/or analyzed on a computer.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013089</value>
                  </attribute>
               </node>
               <node>
                  <name>External-evidence</name>
                  <description>A phenomenon that follows and is caused by some previous phenomenon.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013090</value>
                  </attribute>
               </node>
               <node>
                  <name>Intended-effect</name>
                  <description>A phenomenon that is intended to follow and be caused by some previous phenomenon.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013091</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-event-role</name>
               <description>The purpose of an event with respect to the task.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013092</value>
               </attribute>
               <node>
                  <name>Experimental-stimulus</name>
                  <description>Part of something designed to elicit a response in the experiment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013093</value>
                  </attribute>
               </node>
               <node>
                  <name>Incidental</name>
                  <description>A sensory or other type of event that is unrelated to the task or experiment.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013094</value>
                  </attribute>
               </node>
               <node>
                  <name>Instructional</name>
                  <description>Usually associated with a sensory event intended to give instructions to the participant about the task or behavior.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013095</value>
                  </attribute>
               </node>
               <node>
                  <name>Mishap</name>
                  <description>Unplanned disruption such as an equipment or experiment control abnormality or experimenter error.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013096</value>
                  </attribute>
               </node>
               <node>
                  <name>Participant-response</name>
                  <description>Something related to a participant actions in performing the task.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013097</value>
                  </attribute>
               </node>
               <node>
                  <name>Task-activity</name>
                  <description>Something that is part of the overall task or is necessary to the overall experiment but is not directly part of a stimulus-response cycle. Examples would be taking a survey or provided providing a silva sample.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013098</value>
                  </attribute>
               </node>
               <node>
                  <name>Warning</name>
                  <description>Something that should warn the participant that the parameters of the task have been or are about to be exceeded such as a warning message about getting too close to the shoulder of the road in a driving task.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013099</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-relationship</name>
               <description>Specifying organizational importance of sub-tasks.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013100</value>
               </attribute>
               <node>
                  <name>Background-subtask</name>
                  <description>A part of the task which should be performed in the background as for example inhibiting blinks due to instruction while performing the primary task.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013101</value>
                  </attribute>
               </node>
               <node>
                  <name>Primary-subtask</name>
                  <description>A part of the task which should be the primary focus of the participant.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013102</value>
                  </attribute>
               </node>
            </node>
            <node>
               <name>Task-stimulus-role</name>
               <description>The role the stimulus plays in the task.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013103</value>
               </attribute>
               <node>
                  <name>Cue</name>
                  <description>A signal for an action, a pattern of stimuli indicating a particular response.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013104</value>
                  </attribute>
               </node>
               <node>
                  <name>Distractor</name>
                  <description>A person or thing that distracts or a plausible but incorrect option in a multiple-choice question. In psychological studies this is sometimes referred to as a foil.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013105</value>
                  </attribute>
               </node>
               <node>
                  <name>Expected</name>
                  <description>Considered likely, probable or anticipated. Something of low information value as in frequent non-targets in an RSVP paradigm.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unexpected</value>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Target</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013106</value>
                  </attribute>
               </node>
               <node>
                  <name>Extraneous</name>
                  <description>Irrelevant or unrelated to the subject being dealt with.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013107</value>
                  </attribute>
               </node>
               <node>
                  <name>Feedback</name>
                  <description>An evaluative response to an inquiry, process, event, or activity.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013108</value>
                  </attribute>
               </node>
               <node>
                  <name>Go-signal</name>
                  <description>An indicator to proceed with a planned action.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Stop-signal</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013109</value>
                  </attribute>
               </node>
               <node>
                  <name>Meaningful</name>
                  <description>Conveying significant or relevant information.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013110</value>
                  </attribute>
               </node>
               <node>
                  <name>Newly-learned</name>
                  <description>Representing recently acquired information or understanding.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013111</value>
                  </attribute>
               </node>
               <node>
                  <name>Non-informative</name>
                  <description>Something that is not useful in forming an opinion or judging an outcome.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013112</value>
                  </attribute>
               </node>
               <node>
                  <name>Non-target</name>
                  <description>Something other than that done or looked for. Also tag Expected if the Non-target is frequent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Target</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013113</value>
                  </attribute>
               </node>
               <node>
                  <name>Not-meaningful</name>
                  <description>Not having a serious, important, or useful quality or purpose.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013114</value>
                  </attribute>
               </node>
               <node>
                  <name>Novel</name>
                  <description>Having no previous example or precedent or parallel.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013115</value>
                  </attribute>
               </node>
               <node>
                  <name>Oddball</name>
                  <description>Something unusual, or infrequent.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unexpected</value>
                  </attribute>
                  <attribute>
                     <name>suggestedTag</name>
                     <value>Target</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013116</value>
                  </attribute>
               </node>
               <node>
                  <name>Penalty</name>
                  <description>A disadvantage, loss, or hardship due to some action.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013117</value>
                  </attribute>
               </node>
               <node>
                  <name>Planned</name>
                  <description>Something that was decided on or arranged in advance.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Unplanned</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013118</value>
                  </attribute>
               </node>
               <node>
                  <name>Priming</name>
                  <description>An implicit memory effect in which exposure to a stimulus influences response to a later stimulus.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013119</value>
                  </attribute>
               </node>
               <node>
                  <name>Query</name>
                  <description>A sentence of inquiry that asks for a reply.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013120</value>
                  </attribute>
               </node>
               <node>
                  <name>Reward</name>
                  <description>A positive reinforcement for a desired action, behavior or response.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013121</value>
                  </attribute>
               </node>
               <node>
                  <name>Stop-signal</name>
                  <description>An indicator that the agent should stop the current activity.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Go-signal</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013122</value>
                  </attribute>
               </node>
               <node>
                  <name>Target</name>
                  <description>Something fixed as a goal, destination, or point of examination.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013123</value>
                  </attribute>
               </node>
               <node>
                  <name>Threat</name>
                  <description>An indicator that signifies hostility and predicts an increased probability of attack.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013124</value>
                  </attribute>
               </node>
               <node>
                  <name>Timed</name>
                  <description>Something planned or scheduled to be done at a particular time or lasting for a specified amount of time.</description>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013125</value>
                  </attribute>
               </node>
               <node>
                  <name>Unexpected</name>
                  <description>Something that is not anticipated.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Expected</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013126</value>
                  </attribute>
               </node>
               <node>
                  <name>Unplanned</name>
                  <description>Something that has not been planned as part of the task.</description>
                  <attribute>
                     <name>relatedTag</name>
                     <value>Planned</value>
                  </attribute>
                  <attribute>
                     <name>hedId</name>
                     <value>HED_0013127</value>
                  </attribute>
               </node>
            </node>
         </node>
      </node>
      <node>
         <name>Relation</name>
         <description>Concerns the way in which two or more people or things are connected.</description>
         <attribute>
            <name>extensionAllowed</name>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0013128</value>
         </attribute>
         <node>
            <name>Comparative-relation</name>
            <description>Something considered in comparison to something else. The first entity is the focus.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013129</value>
            </attribute>
            <node>
               <name>Approximately-equal-to</name>
               <description>(A, (Approximately-equal-to, B)) indicates that A and B have almost the same value. Here A and B could refer to sizes, orders, positions or other quantities.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013130</value>
               </attribute>
            </node>
            <node>
               <name>Equal-to</name>
               <description>(A, (Equal-to, B)) indicates that the size or order of A is the same as that of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013131</value>
               </attribute>
            </node>
            <node>
               <name>Greater-than</name>
               <description>(A, (Greater-than, B)) indicates that the relative size or order of A is bigger than that of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013132</value>
               </attribute>
            </node>
            <node>
               <name>Greater-than-or-equal-to</name>
               <description>(A, (Greater-than-or-equal-to, B)) indicates that the relative size or order of A is bigger than or the same as that of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013133</value>
               </attribute>
            </node>
            <node>
               <name>Less-than</name>
               <description>(A, (Less-than, B)) indicates that A is smaller than B. Here A and B could refer to sizes, orders, positions or other quantities.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013134</value>
               </attribute>
            </node>
            <node>
               <name>Less-than-or-equal-to</name>
               <description>(A, (Less-than-or-equal-to, B)) indicates that the relative size or order of A is smaller than or equal to B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013135</value>
               </attribute>
            </node>
            <node>
               <name>Not-equal-to</name>
               <description>(A, (Not-equal-to, B)) indicates that the size or order of A is not the same as that of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013136</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Connective-relation</name>
            <description>Indicates two entities are related in some way. The first entity is the focus.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013137</value>
            </attribute>
            <node>
               <name>Belongs-to</name>
               <description>(A, (Belongs-to, B)) indicates that A is a member of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013138</value>
               </attribute>
            </node>
            <node>
               <name>Connected-to</name>
               <description>(A, (Connected-to, B)) indicates that A is related to B in some respect, usually through a direct link.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013139</value>
               </attribute>
            </node>
            <node>
               <name>Contained-in</name>
               <description>(A, (Contained-in, B)) indicates that A is completely inside of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013140</value>
               </attribute>
            </node>
            <node>
               <name>Described-by</name>
               <description>(A, (Described-by, B)) indicates that B provides information about A.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013141</value>
               </attribute>
            </node>
            <node>
               <name>From-to</name>
               <description>(A, (From-to, B)) indicates a directional relation from A to B. A is considered the source.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013142</value>
               </attribute>
            </node>
            <node>
               <name>Group-of</name>
               <description>(A, (Group-of, B)) indicates A is a group of items of type B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013143</value>
               </attribute>
            </node>
            <node>
               <name>Implied-by</name>
               <description>(A, (Implied-by, B)) indicates B is suggested by A.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013144</value>
               </attribute>
            </node>
            <node>
               <name>Includes</name>
               <description>(A, (Includes, B)) indicates that A has B as a member or part.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013145</value>
               </attribute>
            </node>
            <node>
               <name>Interacts-with</name>
               <description>(A, (Interacts-with, B)) indicates A and B interact, possibly reciprocally.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013146</value>
               </attribute>
            </node>
            <node>
               <name>Member-of</name>
               <description>(A, (Member-of, B)) indicates A is a member of group B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013147</value>
               </attribute>
            </node>
            <node>
               <name>Part-of</name>
               <description>(A, (Part-of, B)) indicates A is a part of the whole B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013148</value>
               </attribute>
            </node>
            <node>
               <name>Performed-by</name>
               <description>(A, (Performed-by, B)) indicates that the action or procedure A was carried out by agent B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013149</value>
               </attribute>
            </node>
            <node>
               <name>Performed-using</name>
               <description>(A, (Performed-using, B)) indicates that the action or procedure A was accomplished using B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013150</value>
               </attribute>
            </node>
            <node>
               <name>Related-to</name>
               <description>(A, (Related-to, B)) indicates A has some relationship to B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013151</value>
               </attribute>
            </node>
            <node>
               <name>Unrelated-to</name>
               <description>(A, (Unrelated-to, B)) indicates that A is not related to B.For example, A is not related to Task.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013152</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Directional-relation</name>
            <description>A relationship indicating direction of change of one entity relative to another. The first entity is the focus.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013153</value>
            </attribute>
            <node>
               <name>Away-from</name>
               <description>(A, (Away-from, B)) indicates that A is going or has moved away from B. The meaning depends on A and B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013154</value>
               </attribute>
            </node>
            <node>
               <name>Towards</name>
               <description>(A, (Towards, B)) indicates that A is going to or has moved to B. The meaning depends on A and B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013155</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Logical-relation</name>
            <description>Indicating a logical relationship between entities. The first entity is usually the focus.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013156</value>
            </attribute>
            <node>
               <name>And</name>
               <description>(A, (And, B)) means A and B are both in effect.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013157</value>
               </attribute>
            </node>
            <node>
               <name>Or</name>
               <description>(A, (Or, B)) means at least one of A and B are in effect.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013158</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Spatial-relation</name>
            <description>Indicating a relationship about position between entities.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013159</value>
            </attribute>
            <node>
               <name>Above</name>
               <description>(A, (Above, B)) means A is in a place or position that is higher than B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013160</value>
               </attribute>
            </node>
            <node>
               <name>Across-from</name>
               <description>(A, (Across-from, B)) means A is on the opposite side of something from B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013161</value>
               </attribute>
            </node>
            <node>
               <name>Adjacent-to</name>
               <description>(A, (Adjacent-to, B)) indicates that A is next to B in time or space.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013162</value>
               </attribute>
            </node>
            <node>
               <name>Ahead-of</name>
               <description>(A, (Ahead-of, B)) indicates that A is further forward in time or space in B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013163</value>
               </attribute>
            </node>
            <node>
               <name>Around</name>
               <description>(A, (Around, B)) means A is in or near the present place or situation of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013164</value>
               </attribute>
            </node>
            <node>
               <name>Behind</name>
               <description>(A, (Behind, B)) means A is at or to the far side of B, typically so as to be hidden by it.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013165</value>
               </attribute>
            </node>
            <node>
               <name>Below</name>
               <description>(A, (Below, B)) means A is in a place or position that is lower than the position of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013166</value>
               </attribute>
            </node>
            <node>
               <name>Between</name>
               <description>(A, (Between, (B, C))) means A is in the space or interval separating B and C.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013167</value>
               </attribute>
            </node>
            <node>
               <name>Bilateral-to</name>
               <description>(A, (Bilateral, B)) means A is on both sides of B or affects both sides of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013168</value>
               </attribute>
            </node>
            <node>
               <name>Bottom-edge-of</name>
               <description>(A, (Bottom-edge-of, B)) means A is on the bottom most part or or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013169</value>
               </attribute>
            </node>
            <node>
               <name>Boundary-of</name>
               <description>(A, (Boundary-of, B)) means A is on or part of the edge or boundary of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013170</value>
               </attribute>
            </node>
            <node>
               <name>Center-of</name>
               <description>(A, (Center-of, B)) means A is at a point or or in an area that is approximately central within B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013171</value>
               </attribute>
            </node>
            <node>
               <name>Close-to</name>
               <description>(A, (Close-to, B)) means A is at a small distance from or is located near in space to B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013172</value>
               </attribute>
            </node>
            <node>
               <name>Far-from</name>
               <description>(A, (Far-from, B)) means A is at a large distance from or is not located near in space to B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013173</value>
               </attribute>
            </node>
            <node>
               <name>In-front-of</name>
               <description>(A, (In-front-of, B)) means A is in a position just ahead or at the front part of B, potentially partially blocking B from view.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013174</value>
               </attribute>
            </node>
            <node>
               <name>Left-edge-of</name>
               <description>(A, (Left-edge-of, B)) means A is located on the left side of B on or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Bottom-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013175</value>
               </attribute>
            </node>
            <node>
               <name>Left-side-of</name>
               <description>(A, (Left-side-of, B)) means A is located on the left side of B usually as part of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Right-side-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013176</value>
               </attribute>
            </node>
            <node>
               <name>Lower-center-of</name>
               <description>(A, (Lower-center-of, B)) means A is situated on the lower center part of B (due south). This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013177</value>
               </attribute>
            </node>
            <node>
               <name>Lower-left-of</name>
               <description>(A, (Lower-left-of, B)) means A is situated on the lower left part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013178</value>
               </attribute>
            </node>
            <node>
               <name>Lower-right-of</name>
               <description>(A, (Lower-right-of, B)) means A is situated on the lower right part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-left-of</value>
                  <value>Lower-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013179</value>
               </attribute>
            </node>
            <node>
               <name>Outside-of</name>
               <description>(A, (Outside-of, B)) means A is located in the space around but not including B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013180</value>
               </attribute>
            </node>
            <node>
               <name>Over</name>
               <description>(A, (Over, B)) means A above is above B so as to cover or protect or A extends over the a general area as from a from a vantage point.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013181</value>
               </attribute>
            </node>
            <node>
               <name>Right-edge-of</name>
               <description>(A, (Right-edge-of, B)) means A is located on the right side of B on or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Bottom-edge-of</value>
                  <value>Left-edge-of</value>
                  <value>Top-edge-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013182</value>
               </attribute>
            </node>
            <node>
               <name>Right-side-of</name>
               <description>(A, (Right-side-of, B)) means A is located on the right side of B usually as part of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-side-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013183</value>
               </attribute>
            </node>
            <node>
               <name>To-left-of</name>
               <description>(A, (To-left-of, B)) means A is located on or directed toward the side to the west of B when B is facing north. This term is used when A is not part of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013184</value>
               </attribute>
            </node>
            <node>
               <name>To-right-of</name>
               <description>(A, (To-right-of, B)) means A is located on or directed toward the side to the east of B when B is facing north. This term is used when A is not part of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013185</value>
               </attribute>
            </node>
            <node>
               <name>Top-edge-of</name>
               <description>(A, (Top-edge-of, B)) means A is on the uppermost part or or near the boundary of B.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Left-edge-of</value>
                  <value>Right-edge-of</value>
                  <value>Bottom-edge-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013186</value>
               </attribute>
            </node>
            <node>
               <name>Top-of</name>
               <description>(A, (Top-of, B)) means A is on the uppermost part, side, or surface of B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013187</value>
               </attribute>
            </node>
            <node>
               <name>Underneath</name>
               <description>(A, (Underneath, B)) means A is situated directly below and may be concealed by B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013188</value>
               </attribute>
            </node>
            <node>
               <name>Upper-center-of</name>
               <description>(A, (Upper-center-of, B)) means A is situated on the upper center part of B (due north). This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013189</value>
               </attribute>
            </node>
            <node>
               <name>Upper-left-of</name>
               <description>(A, (Upper-left-of, B)) means A is situated on the upper left part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Lower-right-of</value>
                  <value>Upper-center-of</value>
                  <value>Upper-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013190</value>
               </attribute>
            </node>
            <node>
               <name>Upper-right-of</name>
               <description>(A, (Upper-right-of, B)) means A is situated on the upper right part of B. This relation is often used to specify qualitative information about screen position.</description>
               <attribute>
                  <name>relatedTag</name>
                  <value>Center-of</value>
                  <value>Lower-center-of</value>
                  <value>Lower-left-of</value>
                  <value>Upper-left-of</value>
                  <value>Upper-center-of</value>
                  <value>Lower-right-of</value>
               </attribute>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013191</value>
               </attribute>
            </node>
            <node>
               <name>Within</name>
               <description>(A, (Within, B)) means A is on the inside of or contained in B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013192</value>
               </attribute>
            </node>
         </node>
         <node>
            <name>Temporal-relation</name>
            <description>A relationship that includes a temporal or time-based component.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0013193</value>
            </attribute>
            <node>
               <name>After</name>
               <description>(A, (After, B)) means A happens at a time subsequent to a reference time related to B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013194</value>
               </attribute>
            </node>
            <node>
               <name>Asynchronous-with</name>
               <description>(A, (Asynchronous-with, B)) means A happens at times not occurring at the same time or having the same period or phase as B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013195</value>
               </attribute>
            </node>
            <node>
               <name>Before</name>
               <description>(A, (Before, B)) means A happens at a time earlier in time or order than B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013196</value>
               </attribute>
            </node>
            <node>
               <name>During</name>
               <description>(A, (During, B)) means A happens at some point in a given period of time in which B is ongoing.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013197</value>
               </attribute>
            </node>
            <node>
               <name>Synchronous-with</name>
               <description>(A, (Synchronous-with, B)) means A happens at occurs at the same time or rate as B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013198</value>
               </attribute>
            </node>
            <node>
               <name>Waiting-for</name>
               <description>(A, (Waiting-for, B)) means A pauses for something to happen in B.</description>
               <attribute>
                  <name>hedId</name>
                  <value>HED_0013199</value>
               </attribute>
            </node>
         </node>
      </node>
   </schema>
   <unitClassDefinitions>
      <unitClassDefinition>
         <name>accelerationUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^2</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011500</value>
         </attribute>
         <unit>
            <name>m-per-s^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>allowedCharacter</name>
               <value>caret</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011600</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>angleUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>radian</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011501</value>
         </attribute>
         <unit>
            <name>radian</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011601</value>
            </attribute>
         </unit>
         <unit>
            <name>rad</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011602</value>
            </attribute>
         </unit>
         <unit>
            <name>degree</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0174533</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011603</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>areaUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^2</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011502</value>
         </attribute>
         <unit>
            <name>m^2</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>allowedCharacter</name>
               <value>caret</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011604</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>currencyUnits</name>
         <description>Units indicating the worth of something.</description>
         <attribute>
            <name>defaultUnits</name>
            <value>$</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011503</value>
         </attribute>
         <unit>
            <name>dollar</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011605</value>
            </attribute>
         </unit>
         <unit>
            <name>$</name>
            <attribute>
               <name>unitPrefix</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>allowedCharacter</name>
               <value>dollar</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011606</value>
            </attribute>
         </unit>
         <unit>
            <name>euro</name>
            <description>The official currency of a large subset of member countries of the European Union.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0011607</value>
            </attribute>
         </unit>
         <unit>
            <name>point</name>
            <description>An arbitrary unit of value, usually an integer indicating reward or penalty.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0011608</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>electricPotentialUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>uV</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011504</value>
         </attribute>
         <unit>
            <name>V</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011609</value>
            </attribute>
         </unit>
         <unit>
            <name>uV</name>
            <description>Added as a direct unit because it is the default unit.</description>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011644</value>
            </attribute>
         </unit>
         <unit>
            <name>volt</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.000001</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011610</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>frequencyUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>Hz</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011505</value>
         </attribute>
         <unit>
            <name>hertz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011611</value>
            </attribute>
         </unit>
         <unit>
            <name>Hz</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011612</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>intensityUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>dB</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011506</value>
         </attribute>
         <unit>
            <name>dB</name>
            <description>Intensity expressed as ratio to a threshold. May be used for sound intensity.</description>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011613</value>
            </attribute>
         </unit>
         <unit>
            <name>candela</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011614</value>
            </attribute>
         </unit>
         <unit>
            <name>cd</name>
            <description>Units used to express light intensity.</description>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011615</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>jerkUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s^3</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011507</value>
         </attribute>
         <unit>
            <name>m-per-s^3</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>allowedCharacter</name>
               <value>caret</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011616</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>magneticFieldUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>T</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011508</value>
         </attribute>
         <unit>
            <name>tesla</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10e-15</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011617</value>
            </attribute>
         </unit>
         <unit>
            <name>T</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>10e-15</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011618</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>memorySizeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>B</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011509</value>
         </attribute>
         <unit>
            <name>byte</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011619</value>
            </attribute>
         </unit>
         <unit>
            <name>B</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011620</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>physicalLengthUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011510</value>
         </attribute>
         <unit>
            <name>foot</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.3048</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011621</value>
            </attribute>
         </unit>
         <unit>
            <name>inch</name>
            <attribute>
               <name>conversionFactor</name>
               <value>0.0254</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011622</value>
            </attribute>
         </unit>
         <unit>
            <name>meter</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011623</value>
            </attribute>
         </unit>
         <unit>
            <name>metre</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011624</value>
            </attribute>
         </unit>
         <unit>
            <name>m</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011625</value>
            </attribute>
         </unit>
         <unit>
            <name>mile</name>
            <attribute>
               <name>conversionFactor</name>
               <value>1609.34</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011626</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>speedUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m-per-s</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011511</value>
         </attribute>
         <unit>
            <name>m-per-s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011627</value>
            </attribute>
         </unit>
         <unit>
            <name>mph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.44704</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011628</value>
            </attribute>
         </unit>
         <unit>
            <name>kph</name>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>0.277778</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011629</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>temperatureUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>degree-Celsius</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011512</value>
         </attribute>
         <unit>
            <name>degree-Celsius</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011630</value>
            </attribute>
         </unit>
         <unit>
            <name>degree Celsius</name>
            <description>Units are not allowed to have spaces. Use degree-Celsius or oC instead.</description>
            <attribute>
               <name>deprecatedFrom</name>
               <value>8.2.0</value>
            </attribute>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011631</value>
            </attribute>
         </unit>
         <unit>
            <name>oC</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011632</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>timeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>s</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011513</value>
         </attribute>
         <unit>
            <name>second</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011633</value>
            </attribute>
         </unit>
         <unit>
            <name>s</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011634</value>
            </attribute>
         </unit>
         <unit>
            <name>day</name>
            <attribute>
               <name>conversionFactor</name>
               <value>86400</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011635</value>
            </attribute>
         </unit>
         <unit>
            <name>month</name>
            <attribute>
               <name>hedId</name>
               <value>HED_0011645</value>
            </attribute>
         </unit>
         <unit>
            <name>minute</name>
            <attribute>
               <name>conversionFactor</name>
               <value>60</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011636</value>
            </attribute>
         </unit>
         <unit>
            <name>hour</name>
            <description>Should be in 24-hour format.</description>
            <attribute>
               <name>conversionFactor</name>
               <value>3600</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011637</value>
            </attribute>
         </unit>
         <unit>
            <name>year</name>
            <description>Years do not have a constant conversion factor to seconds.</description>
            <attribute>
               <name>hedId</name>
               <value>HED_0011638</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>volumeUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>m^3</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011514</value>
         </attribute>
         <unit>
            <name>m^3</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>allowedCharacter</name>
               <value>caret</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011639</value>
            </attribute>
         </unit>
      </unitClassDefinition>
      <unitClassDefinition>
         <name>weightUnits</name>
         <attribute>
            <name>defaultUnits</name>
            <value>g</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011515</value>
         </attribute>
         <unit>
            <name>g</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>unitSymbol</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011640</value>
            </attribute>
         </unit>
         <unit>
            <name>gram</name>
            <attribute>
               <name>SIUnit</name>
            </attribute>
            <attribute>
               <name>conversionFactor</name>
               <value>1.0</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011641</value>
            </attribute>
         </unit>
         <unit>
            <name>pound</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011642</value>
            </attribute>
         </unit>
         <unit>
            <name>lb</name>
            <attribute>
               <name>conversionFactor</name>
               <value>453.592</value>
            </attribute>
            <attribute>
               <name>hedId</name>
               <value>HED_0011643</value>
            </attribute>
         </unit>
      </unitClassDefinition>
   </unitClassDefinitions>
   <unitModifierDefinitions>
      <unitModifierDefinition>
         <name>deca</name>
         <description>SI unit multiple representing 10e1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011400</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>da</name>
         <description>SI unit multiple representing 10e1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011401</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>hecto</name>
         <description>SI unit multiple representing 10e2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011402</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>h</name>
         <description>SI unit multiple representing 10e2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>100.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011403</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>kilo</name>
         <description>SI unit multiple representing 10e3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011404</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>k</name>
         <description>SI unit multiple representing 10e3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>1000.0</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011405</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>mega</name>
         <description>SI unit multiple representing 10e6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e6</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011406</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>M</name>
         <description>SI unit multiple representing 10e6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e6</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011407</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>giga</name>
         <description>SI unit multiple representing 10e9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e9</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011408</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>G</name>
         <description>SI unit multiple representing 10e9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e9</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011409</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>tera</name>
         <description>SI unit multiple representing 10e12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e12</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011410</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>T</name>
         <description>SI unit multiple representing 10e12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e12</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011411</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>peta</name>
         <description>SI unit multiple representing 10e15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e15</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011412</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>P</name>
         <description>SI unit multiple representing 10e15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e15</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011413</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>exa</name>
         <description>SI unit multiple representing 10e18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e18</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011414</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>E</name>
         <description>SI unit multiple representing 10e18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e18</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011415</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zetta</name>
         <description>SI unit multiple representing 10e21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e21</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011416</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Z</name>
         <description>SI unit multiple representing 10e21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e21</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011417</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yotta</name>
         <description>SI unit multiple representing 10e24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e24</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011418</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>Y</name>
         <description>SI unit multiple representing 10e24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e24</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011419</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>deci</name>
         <description>SI unit submultiple representing 10e-1.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011420</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>d</name>
         <description>SI unit submultiple representing 10e-1.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.1</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011421</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>centi</name>
         <description>SI unit submultiple representing 10e-2.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011422</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>c</name>
         <description>SI unit submultiple representing 10e-2.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.01</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011423</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>milli</name>
         <description>SI unit submultiple representing 10e-3.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011424</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>m</name>
         <description>SI unit submultiple representing 10e-3.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>0.001</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011425</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>micro</name>
         <description>SI unit submultiple representing 10e-6.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-6</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011426</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>u</name>
         <description>SI unit submultiple representing 10e-6.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-6</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011427</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>nano</name>
         <description>SI unit submultiple representing 10e-9.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-9</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011428</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>n</name>
         <description>SI unit submultiple representing 10e-9.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-9</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011429</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>pico</name>
         <description>SI unit submultiple representing 10e-12.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-12</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011430</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>p</name>
         <description>SI unit submultiple representing 10e-12.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-12</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011431</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>femto</name>
         <description>SI unit submultiple representing 10e-15.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-15</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011432</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>f</name>
         <description>SI unit submultiple representing 10e-15.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-15</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011433</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>atto</name>
         <description>SI unit submultiple representing 10e-18.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-18</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011434</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>a</name>
         <description>SI unit submultiple representing 10e-18.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-18</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011435</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>zepto</name>
         <description>SI unit submultiple representing 10e-21.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-21</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011436</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>z</name>
         <description>SI unit submultiple representing 10e-21.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-21</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011437</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>yocto</name>
         <description>SI unit submultiple representing 10e-24.</description>
         <attribute>
            <name>SIUnitModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-24</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011438</value>
         </attribute>
      </unitModifierDefinition>
      <unitModifierDefinition>
         <name>y</name>
         <description>SI unit submultiple representing 10e-24.</description>
         <attribute>
            <name>SIUnitSymbolModifier</name>
         </attribute>
         <attribute>
            <name>conversionFactor</name>
            <value>10e-24</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011439</value>
         </attribute>
      </unitModifierDefinition>
   </unitModifierDefinitions>
   <valueClassDefinitions>
      <valueClassDefinition>
         <name>dateTimeClass</name>
         <description>Date-times should conform to ISO8601 date-time format YYYY-MM-DDThh:mm:ss.000000Z (year, month, day, hour (24h), minute, second, optional fractional seconds, and optional UTC time indicator. Any variation on the full form is allowed.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>T</value>
            <value>hyphen</value>
            <value>colon</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011301</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>nameClass</name>
         <description>Value class designating values that have the characteristics of node names. The allowed characters are alphanumeric, hyphen, and underscore.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>letters</value>
            <value>digits</value>
            <value>underscore</value>
            <value>hyphen</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011302</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>numericClass</name>
         <description>Value must be a valid numerical value.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>E</value>
            <value>e</value>
            <value>plus</value>
            <value>hyphen</value>
            <value>period</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011303</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>posixPath</name>
         <description>Posix path specification.</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>digits</value>
            <value>letters</value>
            <value>slash</value>
            <value>colon</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011304</value>
         </attribute>
      </valueClassDefinition>
      <valueClassDefinition>
         <name>textClass</name>
         <description>Values that have the characteristics of text such as in descriptions. The text characters include printable characters (32 &lt;= ASCII&lt; 127) excluding comma, square bracket and curly braces as well as non ASCII (ASCII codes &gt; 127).</description>
         <attribute>
            <name>allowedCharacter</name>
            <value>text</value>
         </attribute>
         <attribute>
            <name>hedId</name>
            <value>HED_0011305</value>
         </attribute>
      </valueClassDefinition>
   </valueClassDefinitions>
   <schemaAttributeDefinitions>
      <schemaAttributeDefinition>
         <name>hedId</name>
         <description>The unique identifier of this element in the HED namespace.</description>
         <property>
            <name>elementDomain</name>
         </property>
         <property>
            <name>stringRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010500</value>
         </property>
         <property>
            <name>annotationProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>requireChild</name>
         <description>This tag must have a descendent.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010501</value>
         </property>
         <property>
            <name>annotationProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>rooted</name>
         <description>This top-level library schema node should have a parent which is the indicated node in the partnered standard schema.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>tagRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010502</value>
         </property>
         <property>
            <name>annotationProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>takesValue</name>
         <description>This tag is a hashtag placeholder that is expected to be replaced with a user-defined value.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010503</value>
         </property>
         <property>
            <name>annotationProperty</name>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>defaultUnits</name>
         <description>The default units to use if the placeholder has a unit class but the substituted value has no units.</description>
         <property>
            <name>unitClassDomain</name>
         </property>
         <property>
            <name>unitRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010104</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>isPartOf</name>
         <description>This tag is part of the indicated tag -- as in the nose is part of the face.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>tagRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010109</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>relatedTag</name>
         <description>A HED tag that is closely related to this tag. This attribute is used by tagging tools.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>tagRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010105</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>suggestedTag</name>
         <description>A tag that is often associated with this tag. This attribute is used by tagging tools to provide tagging suggestions.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>tagRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010106</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitClass</name>
         <description>The unit class that the value of a placeholder node can belong to.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>unitClassRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010107</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>valueClass</name>
         <description>Type of value taken on by the value of a placeholder node.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>valueClassRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010108</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>allowedCharacter</name>
         <description>A special character that is allowed in expressing the value of a placeholder of a specified value class. Allowed characters may be listed individual, named individually, or named as a group as specified in Section 2.2 Character sets and restrictions of the HED specification.</description>
         <property>
            <name>unitDomain</name>
         </property>
         <property>
            <name>unitModifierDomain</name>
         </property>
         <property>
            <name>valueClassDomain</name>
         </property>
         <property>
            <name>stringRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010304</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>conversionFactor</name>
         <description>The factor to multiply these units or unit modifiers by to convert to default units.</description>
         <property>
            <name>unitDomain</name>
         </property>
         <property>
            <name>unitModifierDomain</name>
         </property>
         <property>
            <name>numericRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010305</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>deprecatedFrom</name>
         <description>The latest schema version in which the element was not deprecated.</description>
         <property>
            <name>elementDomain</name>
         </property>
         <property>
            <name>stringRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010306</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>extensionAllowed</name>
         <description>Users can add unlimited levels of child nodes under this tag. This tag is propagated to child nodes except for hashtag placeholders.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010307</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>inLibrary</name>
         <description>The named library schema that this schema element is from. This attribute is added by tools when a library schema is merged into its partnered standard schema.</description>
         <property>
            <name>elementDomain</name>
         </property>
         <property>
            <name>stringRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010309</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>reserved</name>
         <description>This tag has special meaning and requires special handling by tools.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010310</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnit</name>
         <description>This unit element is an SI unit and can be modified by multiple and sub-multiple names. Note that some units such as byte are designated as SI units although they are not part of the standard.</description>
         <property>
            <name>unitDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010311</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitModifier</name>
         <description>This SI unit modifier represents a multiple or sub-multiple of a base unit rather than a unit symbol.</description>
         <property>
            <name>unitModifierDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010312</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>SIUnitSymbolModifier</name>
         <description>This SI unit modifier represents a multiple or sub-multiple of a unit symbol rather than a base symbol.</description>
         <property>
            <name>unitModifierDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010313</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>tagGroup</name>
         <description>This tag can only appear inside a tag group.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010314</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>topLevelTagGroup</name>
         <description>This tag (or its descendants) can only appear in a top-level tag group. There are additional tag-specific restrictions on what other tags can appear in the group with this tag.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010315</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unique</name>
         <description>Only one of this tag or its descendants can be used in the event-level HED string.</description>
         <property>
            <name>tagDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010316</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitPrefix</name>
         <description>This unit is a prefix unit (e.g., dollar sign in the currency units).</description>
         <property>
            <name>unitDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010317</value>
         </property>
      </schemaAttributeDefinition>
      <schemaAttributeDefinition>
         <name>unitSymbol</name>
         <description>This tag is an abbreviation or symbol representing a type of unit. Unit symbols represent both the singular and the plural and thus cannot be pluralized.</description>
         <property>
            <name>unitDomain</name>
         </property>
         <property>
            <name>boolRange</name>
         </property>
         <property>
            <name>hedId</name>
            <value>HED_0010318</value>
         </property>
      </schemaAttributeDefinition>
   </schemaAttributeDefinitions>
   <propertyDefinitions>
      <propertyDefinition>
         <name>annotationProperty</name>
         <description>The value is not inherited by child nodes.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010701</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>boolRange</name>
         <description>This schema attribute's value can be true or false. This property was formerly named boolProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010702</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>elementDomain</name>
         <description>This schema attribute can apply to any type of element class (i.e., tag, unit, unit class, unit modifier, or value class). This property was formerly named elementProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010703</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>tagDomain</name>
         <description>This schema attribute can apply to node (tag-term) elements. This was added so attributes could apply to multiple types of elements. This property was formerly named nodeProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010704</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>tagRange</name>
         <description>This schema attribute's value can be a node. This property was formerly named nodeProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010705</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>numericRange</name>
         <description>This schema attribute's value can be numeric.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010706</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>stringRange</name>
         <description>This schema attribute's value can be a string.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010707</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitClassDomain</name>
         <description>This schema attribute can apply to unit classes. This property was formerly named unitClassProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010708</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitClassRange</name>
         <description>This schema attribute's value can be a unit class.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010709</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitModifierDomain</name>
         <description>This schema attribute can apply to unit modifiers. This property was formerly named unitModifierProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010710</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitDomain</name>
         <description>This schema attribute can apply to units. This property was formerly named unitProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010711</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>unitRange</name>
         <description>This schema attribute's value can be units.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010712</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>valueClassDomain</name>
         <description>This schema attribute can apply to value classes. This property was formerly named valueClassProperty.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010713</value>
         </property>
      </propertyDefinition>
      <propertyDefinition>
         <name>valueClassRange</name>
         <description>This schema attribute's value can be a value class.</description>
         <property>
            <name>hedId</name>
            <value>HED_0010714</value>
         </property>
      </propertyDefinition>
   </propertyDefinitions>
   <epilogue>This schema is released under the Creative Commons Attribution 4.0 International and is a product of the HED Working Group. The DOI for the latest version of the HED standard schema is 10.5281/zenodo.7876037.</epilogue>
</HED>
